// Reviewed static reception UI copy. Customer values and exam content are never catalog keys.
export const pageArabicTranslations: Record<string, string> = {
  "Failed to resolve reception access scope.": "تعذر تحميل نطاق الوصول للاستقبال.",
  "Your reception account does not have a valid branch scope.": "حساب الاستقبال ليس مرتبطًا بنطاق فرع صالح.",
  "Failed to load daily reports ({0}){1}": "تعذر تحميل التقارير اليومية ({0}){1}",
  "Failed to load report.": "تعذر تحميل التقرير.",
  "Report not found.": "التقرير غير موجود.",
  "You do not have permission to view this report.": "ليس لديك صلاحية لعرض هذا التقرير.",
  'The selected booking changed. Your draft is preserved; select the intended booking before collecting payment.': 'الحجز المعروض اتغيّر. مسودتك محفوظة؛ اختار الحجز المقصود قبل تحصيل الدفعة.',
  'Unassigned additional services': 'خدمات إضافية غير مرتبطة بحجز محدد',
  'Separate language packages require a language course': 'حجز باقات اللغة المستقلة متاح لكورسات اللغات فقط',
  'Concurrent packages require independent booking identity': 'حجز الباقات معًا يتطلب حساب حجز مستقل لكل باقة',
  'Verify the existing language package and current level before booking another package': 'راجع بيانات باقة اللغة الحالية والمستوى قبل حجز باقة أخرى',
  'The requested package exceeds the remaining unbooked language levels': 'الباقة المطلوبة تتجاوز المستويات المتاحة التي لم يتم حجزها',
  'Overlapping package identities require review before selecting a booking': 'يوجد تداخل بين مستويات الباقات؛ يلزم مراجعته قبل اختيار الحجز',
  'These language levels already belong to another package': 'المستويات دي محجوزة بالفعل ضمن باقة أخرى',
  'Separate prepaid packages require booking-level review before transferring course payments': 'توجد باقات مستقلة محجوزة مقدمًا؛ يلزم تحديد الحجز ومراجعته قبل نقل مدفوعات الكورس',

  'Available package levels changed. Your draft is preserved; review existing bookings before starting a new package.': 'المستويات المتاحة للحجز اتغيّرت. مسودتك محفوظة؛ راجع الحجوزات الموجودة قبل بدء باقة جديدة.',
  'Book New Package': 'حجز باقة جديدة',
  'Book Package & Issue Invoice': 'حجز الباقة وإصدار فاتورة',
  'New package in progress': 'حجز باقة جديدة',
  'New package review': 'مراجعة الباقة الجديدة',
  'New package starts at {0}. Maximum {1}.': 'الباقة الجديدة تبدأ من {0}. الحد الأقصى {1}.',

  'Separate package booking is currently unavailable. Please contact management before collecting a payment.': 'الحجز المستقل للباقة غير متاح حاليًا. تواصل مع الإدارة قبل تحصيل دفعة للباقة الجديدة.',
  'Package accounts': 'حسابات الباقات',
  'Current booking': 'الحجز الحالي',
  'Booking': 'حجز',
  'New Package Price': 'سعر الباقة الجديدة',
  'New Package Paid': 'مدفوعات الباقة الجديدة',
  'The new package has a separate booking and balance. Previous receipts and payments stay with their original booking. Enter only a new payment, never an amount already receipted.': 'الباقة الجديدة لها حجز ورصيد مستقلان. الإيصالات والمدفوعات السابقة تفضل على حجزها الأصلي. سجّل دفعة جديدة فقط، وليس مبلغًا له إيصال سابق.',

  'Language package renewal review': 'مراجعة تجديد باقة اللغة',
  'New package levels': 'مستويات الباقة الجديدة',
  '{0} — Level {1}': '{0} — المستوى {1}',
  'Total Price After Renewal': 'إجمالي السعر بعد التجديد',
  'Total Paid After Renewal': 'إجمالي المدفوع بعد التجديد',
  'Renewal adds a new offer to the course balance. Previous receipts and payments are retained; the totals below include both packages.': 'التجديد بيضيف عرض جديد لحساب الكورس مع الاحتفاظ بالإيصالات والمدفوعات السابقة. الإجماليات التالية بتشمل الباقتين.',
  'For a new language package, use Renew Package. Changing the old price does not create a new package.': 'لحجز باقة لغة جديدة، استخدم تجديد الباقة. تغيير السعر القديم مش بيعمل حجز باقة جديدة.',
  "Showing {0} payment requests": "عرض {0} طلبات دفع",
  "Needs grading": "محتاج تصحيح",
  "No invoices waiting for review.": "مفيش طلبات دفع مستنية المراجعة.",
  "No approved invoices in this view.": "مفيش طلبات دفع موافق عليها في العرض ده.",
  "No rejected invoices in this view.": "مفيش طلبات دفع مرفوضة في العرض ده.",
  "No pending refund requests": "مفيش طلبات استرداد مستنية المراجعة.",
  "No approved refund requests": "مفيش طلبات استرداد موافق عليها.",
  "No scheduled refund requests": "مفيش طلبات استرداد مجدولة.",
  "No rejected refund requests": "مفيش طلبات استرداد مرفوضة.",
  "Exam assignment": "تخصيص الامتحان",
  "Advanced settings": "إعدادات متقدمة",
  "Exam tools and materials": "أدوات الامتحانات والمواد التعليمية",
  "Results and review": "النتائج والمراجعة",
  "Placement and level exam submissions": "محاولات تحديد المستوى وامتحانات المستويات",
  "Active Placement Exams": "امتحانات تحديد المستوى المفعّلة",
  "Enabled placement tests": "اختبارات تحديد المستوى المفعّلة",
  "Absent": "غايب",
  "Absent students": "الطلاب الغايبين",
  "Academic records": "السجل الدراسي",
  "Academy-wide": "كل الأكاديمية",
  "Academic": "أكاديمي",
  "Daily branch work": "العمل اليومي للفرع",
  "Failed to fetch": "تعذر تحميل البيانات",
  "Generated on": "تم الإنشاء في",
  "Hr": "الموارد البشرية",
  "Income payment method": "طريقة دفع الإيراد",
  "Income period": "فترة الإيراد",
  "Income status": "حالة الإيراد",
  "Last 14 days": "آخر 14 يوم",
  "Last 60 days": "آخر 60 يوم",
  "Maintenance": "الصيانة",
  "Operations": "التشغيل",
  "Report Branch": "فرع التقرير",
  "Sales": "المبيعات",
  "Student Success": "نجاح الطلاب",
  "Supplies": "المستلزمات",
  "Walk In": "زيارة مباشرة",
  "Assigned branch + Online": "الفرع المخصص + أونلاين",
  "Calendar grid": "شبكة التقويم",
  "Create one group.": "أنشئ مجموعة واحدة.",
  "No recommendation available.": "لا توجد توصية متاحة.",
  "No branch assigned": "لا يوجد فرع مخصص",
  "Overall demand — search filters the lists below": "إجمالي الطلب — البحث يفلتر القوائم اللي تحت",
  "Pagination": "ترقيم الصفحات",
  "{0}-{1} of {2} groups": "{0}-{1} من {2} مجموعة",
  "{0} groups": "{0} مجموعة",
  "{0} more sessions": "{0} حصص إضافية",
  "Showing {0} of {1} groups": "عرض {0} من {1} مجموعة",
  "{0} student": "{0} طالب",
  "View {0} absent students": "عرض {0} من الطلاب الغايبين",
  "Accept": "قبول",
  "Account & Payments": "الحساب والمدفوعات",
  "Account Summary": "ملخص الحساب",
  "Accountant approved": "المحاسب وافق",
  "Accountant rejected": "المحاسب رفض",
  "Accounting code": "الكود المحاسبي",
  "Acquisition Details": "تفاصيل مصدر العميل",
  "Acquisition Source Verification": "تأكيد مصدر العميل",
  "Action": "الإجراء",
  "Actions": "الإجراءات",
  "Activate": "تفعيل",
  "Activate this student?": "تفعيل الطالب ده؟",
  "Active": "نشط",
  "Active / Published": "نشط / منشور",
  "Active and inactive": "نشط وغير نشط",
  "Active Coupons": "الكوبونات النشطة",
  "Active Groups": "المجموعات النشطة",
  "Active State": "حالة التفعيل",
  "Active students": "الطلاب النشطين",
  "Activity History": "سجل النشاط",
  "Add": "إضافة",
  "Add a comment or note about this student...": "اكتب تعليق أو ملاحظة عن الطالب...",
  "Add a comment...": "اكتب تعليق...",
  "Add a new student": "إضافة طالب جديد",
  "Add Additional Course": "إضافة كورس تاني",
  "Add alternate phone numbers (comma separated)": "اكتب أرقام تليفون بديلة وافصل بينها بفاصلة",
  "Add Another Installment": "إضافة قسط تاني",
  "Add Another Task": "إضافة مهمة تانية",
  "Add any additional details about this session...": "اكتب أي تفاصيل إضافية عن الحصة...",
  "Add at least one installment with amount and due date": "ضيف قسط واحد على الأقل بالمبلغ وتاريخ الاستحقاق",
  "Add clear feedback for the employee...": "اكتب ملاحظات واضحة للموظف...",
  "Add Expense": "إضافة مصروف",
  "Add Expense Entry": "إضافة سجل مصروف",
  "Add failed": "الإضافة ما تمتّش",
  "Add Group": "إضافة مجموعة",
  "Add Income": "إضافة إيراد",
  "Add Income Entry": "إضافة سجل إيراد",
  "Add Link": "إضافة لينك",
  "Add option": "إضافة اختيار",
  "Add or confirm required task data.": "ضيف أو أكد البيانات المطلوبة للمهمة.",
  "Add Question": "إضافة سؤال",
  "Add question to section": "إضافة سؤال للقسم",
  "Add real question text before saving the exam.": "اكتب نص السؤال قبل حفظ الامتحان.",
  "Add section": "إضافة قسم",
  "Add service": "إضافة خدمة",
  "Add Slot": "إضافة ميعاد",
  "Add Student": "إضافة طالب",
  "Add the first comment to start tracking notes about this student.": "اكتب أول تعليق لتسجيل ملاحظات الطالب.",
  "Add to Group": "إضافة لمجموعة",
  "Additional details...": "تفاصيل إضافية...",
  "Additional Income": "إيرادات إضافية",
  "Additional Service": "خدمة إضافية",
  "Additional service payment. This does not reduce course balance.": "دفع خدمة إضافية. المبلغ ده مش بيقلل باقي حساب الكورس.",
  "Additional services by accounting classification": "الخدمات الإضافية حسب التصنيف المحاسبي",
  "Additional Services Paid": "الخدمات الإضافية المدفوعة",
  "Additional Services Revenue": "إيرادات الخدمات الإضافية",
  "Address": "العنوان",
  "Adds new sequential levels": "بيضيف مستويات متتالية جديدة",
  "Administration & Audit": "الإدارة والمراجعة",
  "Advanced Filters": "فلاتر إضافية",
  "AI extraction": "استخراج بالذكاء الاصطناعي",
  "AI Extraction Plan": "خطة الاستخراج بالذكاء الاصطناعي",
  "AI Feedback": "ملاحظات الذكاء الاصطناعي",
  "AI import": "استيراد بالذكاء الاصطناعي",
  "AI Import Progress": "متابعة الاستيراد بالذكاء الاصطناعي",
  "Alert Settings": "إعدادات التنبيهات",
  "All": "الكل",
  "All active entries": "كل السجلات النشطة",
  "All Branches": "كل الفروع",
  "All campuses": "كل المقرات",
  "All categories": "كل التصنيفات",
  "All Courses": "كل الكورسات",
  "All Employees": "كل الموظفين",
  "All Groups": "كل المجموعات",
  "All Instructors": "كل المدربين",
  "All Invoices": "كل الفواتير",
  "All Languages": "كل اللغات",
  "All Levels": "كل المستويات",
  "All material types": "كل أنواع المواد",
  "All Methods": "كل الطرق",
  "All Months": "كل الشهور",
  "All payment methods": "كل طرق الدفع",
  "All physical branches": "كل الفروع الفعلية",
  "All Places": "كل الأماكن",
  "All Priorities": "كل الأولويات",
  "All Priority": "كل الأولويات",
  "All Reports": "كل التقارير",
  "All request types": "كل أنواع الطلبات",
  "All Reviews": "كل المراجعات",
  "All Sessions": "كل الحصص",
  "All States": "كل الحالات",
  "All Status": "كل الحالات",
  "All statuses": "كل الحالات",
  "All Students": "كل الطلاب",
  "All students are already marked as present": "كل الطلاب متسجلين حاضر بالفعل",
  "All submitted tasks have been reviewed.": "كل المهام اللي اتبعتت اتراجعت.",
  "All tasks": "كل المهام",
  "All Tasks Overview": "نظرة على كل المهام",
  "All training types": "كل أنواع التدريب",
  "All Types": "كل الأنواع",
  "All Visibility": "كل حالات الظهور",
  "All Years": "كل السنين",
  "Allocated": "المخصص",
  "Already accepted": "اتقبل بالفعل",
  "Amount": "المبلغ",
  "Amount (EGP)": "المبلغ (ج.م)",
  "Amount Due = 0 EGP · No cash collection or course payment will be recorded.": "المبلغ المستحق = 0 ج.م · مش هيتسجل تحصيل نقدي أو دفع للكورس.",
  "Amount from this receipt (EGP)": "المبلغ من الإيصال ده (ج.م)",
  "Answer": "الإجابة",
  "Answered": "اتجاوب",
  "Any": "أي",
  "Any employee ID": "أي رقم موظف",
  "Any group state": "أي حالة مجموعة",
  "Any instructor": "أي مدرب",
  "Any language": "أي لغة",
  "Any log level": "أي مستوى سجل",
  "Any month": "أي شهر",
  "Any priority": "أي أولوية",
  "Any session type": "أي نوع حصة",
  "Any staff member": "أي موظف",
  "Any student status": "أي حالة طالب",
  "Any task state": "أي حالة مهمة",
  "Any Time": "أي وقت",
  "Any waiting record": "أي سجل انتظار",
  "Any workflow state": "أي حالة إجراء",
  "Any year": "أي سنة",
  "Apply": "تطبيق",
  "Approval Center": "مركز الموافقات",
  "Approval Center filters": "فلاتر مركز الموافقات",
  "Approval Center views": "طرق عرض مركز الموافقات",
  "Approval note...": "ملاحظة الموافقة...",
  "Approval reason": "سبب الموافقة",
  "Approval reason (at least 10 characters)": "سبب الموافقة (10 حروف على الأقل)",
  "Approve": "موافقة",
  "Approve Invoice": "موافقة على الفاتورة",
  "Approve or reject": "موافقة أو رفض",
  "Approve Refund": "موافقة على الاسترداد",
  "Approve Request": "موافقة على الطلب",
  "Approve Sales Invoice": "موافقة على فاتورة المبيعات",
  "Approve Student": "موافقة على الطالب",
  "Approve this expense entry?": "توافق على سجل المصروف ده؟",
  "Approve this income entry?": "توافق على سجل الإيراد ده؟",
  "Approved": "تمت الموافقة",
  "Approved action": "الإجراء المعتمد",
  "Approved Amount": "المبلغ المعتمد",
  "Approved Amount (EGP)": "المبلغ المعتمد (ج.م)",
  "Approved at": "تاريخ الموافقة",
  "Approved by": "وافق عليه",
  "Approved excuses": "الأعذار المقبولة",
  "Approved only": "المعتمد بس",
  "Approved payment": "دفعة معتمدة",
  "Approved refund amount": "مبلغ الاسترداد المعتمد",
  "Approved Today": "الموافقات النهارده",
  "Approving this invoice creates an official student invoice and moves the payment into the approved flow.": "الموافقة على الفاتورة بتنشئ فاتورة رسمية للطالب وبتنقل الدفعة لمسار المدفوعات المعتمدة.",
  "Archive": "أرشيف",
  "Archived audio answer": "الإجابة الصوتية المحفوظة",
  "Archived Questions": "الأسئلة المحفوظة",
  "Are you sure you want to delete this material? This cannot be undone.": "متأكد إنك عايز تحذف المادة دي؟ الحذف مش ممكن يتراجع.",
  "Asc": "تصاعدي",
  "Assign Group": "تعيين مجموعة",
  "Assign Student": "تعيين طالب",
  "Assigned and not started": "متعيّنة ولسه ما بدأتش",
  "Assigned Branch + Online": "الفرع المخصص + أونلاين",
  "Assigned scope": "النطاق المخصص",
  "Assigned Tasks": "المهام المتعيّنة",
  "Assigned to": "متعيّنة لـ",
  "Assignments": "التكليفات",
  "Attempt details": "تفاصيل المحاولة",
  "Attempt details are unavailable.": "تفاصيل المحاولة مش متاحة.",
  "Attempts": "المحاولات",
  "Attendance": "الحضور",
  "Attendance Availability / طريقة الحضور": "طريقة الحضور المتاحة",
  "Attendance Comment": "تعليق الحضور",
  "Add comment for {0}": "إضافة تعليق لـ {0}",
  "Close comment": "إغلاق التعليق",
  "Attendance Done": "الحضور اتسجل",
  "Attendance Matrix": "جدول الحضور",
  "Attendance Matrix - All Groups": "جدول الحضور - كل المجموعات",
  "Attendance Progress": "متابعة الحضور",
  "Attendance Session": "حصة الحضور",
  "Attendance Sessions": "حصص الحضور",
  "Attendance Sheet": "كشف الحضور",
  "Attendance updated": "الحضور اتحدّث",
  "Attendance updates saved": "تعديلات الحضور اتحفظت",
  "Audience": "الفئة المستهدفة",
  "Audio": "صوت",
  "Audio and image files can be uploaded after saving from the edit page.": "ممكن ترفع ملفات الصوت والصور بعد الحفظ من صفحة التعديل.",
  "Audio prompt + questions": "مقطع صوتي + أسئلة",
  "Audio Response (Speaking)": "إجابة صوتية (محادثة)",
  "Audit": "مراجعة",
  "Audit Exam": "مراجعة الامتحان",
  "Audit Filters": "فلاتر المراجعة",
  "Audit Log": "سجل المراجعة",
  "Auto classification": "تصنيف تلقائي",
  "Auto detect": "تحديد تلقائي",
  "Auto-calculated": "محسوب تلقائيًا",
  "Auto-Divide Remaining Amount": "تقسيم المبلغ الباقي تلقائيًا",
  "Auto-Divide Settings": "إعدادات التقسيم التلقائي",
  "Auto-generated": "بيتعمل تلقائيًا",
  "Auto: Course Name + counter": "تلقائي: اسم الكورس + رقم متسلسل",
  "Available": "متاح",
  "Available exams": "الامتحانات المتاحة",
  "Available Groups": "المجموعات المتاحة",
  "Available Seats": "الأماكن المتاحة",
  "Average Transaction": "متوسط المعاملة",
  "Awaiting approval": "مستني موافقة",
  "Awaiting reception confirmation": "مستني تأكيد الريسبشن",
  "Back": "رجوع",
  "Back to AI Import": "رجوع للاستيراد بالذكاء الاصطناعي",
  "Back to Exams": "رجوع للامتحانات",
  "Back to Group": "رجوع للمجموعة",
  "Balance due date": "تاريخ استحقاق الباقي",
  "Bank payment": "دفع بنكي",
  "Bank transfer": "تحويل بنكي",
  "Begin": "بداية",
  "Begin Date": "تاريخ البداية",
  "Begin date month": "شهر البداية",
  "Begin date year": "سنة البداية",
  "Begin From": "البداية من",
  "Begin To": "البداية لحد",
  "Binary questions": "أسئلة صح أو غلط",
  "Bookable now": "متاح للحجز دلوقتي",
  "Booked": "محجوز",
  "Branch": "الفرع",
  "Branch (optional)": "الفرع (اختياري)",
  "Branch *": "الفرع *",
  "Branch / Training": "الفرع / التدريب",
  "Branch cashbox": "خزنة الفرع",
  "Branch Contribution": "مساهمة الفرع",
  "Branch Finance": "حسابات الفرع",
  "Branch is locked to your assigned branch": "الفرع ثابت على الفرع المخصص ليك",
  "Branch payment": "دفع في الفرع",
  "Branch room / online": "قاعة الفرع / أونلاين",
  "Branch scope": "نطاق الفرع",
  "Branch transfers": "تحويلات الفروع",
  "Branch visit": "زيارة الفرع",
  "Branch, cost center, category, and payment method are required": "الفرع ومركز التكلفة والتصنيف وطريقة الدفع مطلوبين",
  "Browse Files": "اختار ملفات",
  "Bulk view": "عرض مجمّع",
  "By Branch": "حسب الفرع",
  "By Course": "حسب الكورس",
  "By Employee": "حسب الموظف",
  "By Payment Method": "حسب طريقة الدفع",
  "By Source": "حسب المصدر",
  "Call Lead": "اتصل بالعميل المحتمل",
  "Callback URL": "لينك استقبال النتيجة",
  "Called": "تم الاتصال",
  "Can wait": "ممكن يستنى",
  "Cancel": "إلغاء",
  "Cancel Renewal": "إلغاء التجديد",
  "Cancel Session": "إلغاء الحصة",
  "Canceled": "ملغي",
  "Cancellation Reason": "سبب الإلغاء",
  "Cancellation Rejected": "الإلغاء اترفض",
  "Cancellation request pending manager approval. The payment remains active.": "طلب الإلغاء مستني موافقة المدير. الدفعة لسه نشطة.",
  "Cancellation request submitted for approval": "طلب الإلغاء اتبعت للموافقة",
  "Cancelled": "ملغي",
  "Capacity": "السعة",
  "Captions": "التعليقات التوضيحية",
  "Cash": "نقدي",
  "Cash payment": "دفع نقدي",
  "Category": "التصنيف",
  "Category *": "التصنيف *",
  "CEO name": "اسم المدير التنفيذي",
  "Certificate image downloaded.": "صورة الشهادة اتحملت.",
  "Certificate no.": "رقم الشهادة",
  "Certificate PDF downloaded.": "ملف PDF للشهادة اتحمّل.",
  "Certificate register": "سجل الشهادات",
  "Certificate results": "نتايج الشهادة",
  "Certificate revoked and recorded in the audit log.": "الشهادة اتلغت واتسجلت في سجل المراجعة.",
  "Certificate signatures": "توقيعات الشهادة",
  "Certificate title": "عنوان الشهادة",
  "Certificates": "الشهادات",
  "Change": "تغيير",
  "Change Course": "تغيير الكورس",
  "Change Course / Transfer": "تغيير الكورس / تحويل",
  "Change Price": "تغيير السعر",
  "Change reason": "سبب التغيير",
  "Change Training Type": "تغيير نوع التدريب",
  "Chat": "الشات",
  "Checklist": "قائمة المراجعة",
  "Choices with correct answer": "اختيارات بإجابة صحيحة",
  "Choose a branch from your current reception scope": "اختار فرع من نطاق الريسبشن المتاح ليك",
  "Choose a certificate to revoke.": "اختار الشهادة اللي عايز تلغيها.",
  "Choose a course from the scoped course catalog": "اختار كورس من الكتالوج المتاح ليك",
  "Choose a question type above to start building the exam.": "اختار نوع سؤال من فوق عشان تبدأ الامتحان.",
  "Choose a registered course": "اختار كورس مسجل",
  "Choose a student first.": "اختار طالب الأول.",
  "Choose a valid date and consultation type": "اختار تاريخ ونوع استشارة صحيحين",
  "Choose a valid task type, priority, and due date.": "اختار نوع مهمة وأولوية وتاريخ استحقاق صحيحين.",
  "Choose branch": "اختار الفرع",
  "Choose classification": "اختار التصنيف",
  "Choose course": "اختار الكورس",
  "Choose course registration": "اختار تسجيل الكورس",
  "Choose delivery mode": "اختار طريقة الحضور",
  "Choose group": "اختار المجموعة",
  "Choose Purpose": "اختار الغرض",
  "Choose the training end date.": "اختار تاريخ نهاية التدريب.",
  "Choose the training start date.": "اختار تاريخ بداية التدريب.",
  "Choose training type": "اختار نوع التدريب",
  "Classification": "التصنيف",
  "Clear": "مسح",
  "Clear Dates": "مسح التواريخ",
  "Clear Filter": "مسح الفلتر",
  "Clear Filters": "مسح الفلاتر",
  "Clear filters or create a new exam.": "امسح الفلاتر أو اعمل امتحان جديد.",
  "Clear search": "مسح البحث",
  "Click to attach TXT or PDF · max 50MB": "اضغط لرفع TXT أو PDF · بحد أقصى 50MB",
  "Click to enlarge": "اضغط للتكبير",
  "Click to upload receipt image": "اضغط لرفع صورة الإيصال",
  "Clone": "نسخ",
  "Clone failed": "النسخ ما تمّش",
  "Close": "قفل",
  "Close absent students": "قفل الطلاب الغايبين",
  "Close absent students backdrop": "قفل نافذة الطلاب الغايبين",
  "Close action dialog": "قفل نافذة الإجراء",
  "Close attempt details": "قفل تفاصيل المحاولة",
  "Close certificate form": "قفل نموذج الشهادة",
  "Close invoice details": "قفل تفاصيل الفاتورة",
  "Close link material": "قفل نافذة لينك المادة",
  "Close log details": "قفل تفاصيل السجل",
  "Close payment details": "قفل تفاصيل الدفعة",
  "Close preview": "قفل المعاينة",
  "Close receipt": "قفل الإيصال",
  "Close refund details": "قفل تفاصيل الاسترداد",
  "Close report": "قفل التقرير",
  "Close section editor": "قفل تعديل القسم",
  "Close student financial history": "قفل سجل حساب الطالب",
  "Close task checklist": "قفل قائمة مراجعة المهمة",
  "Code": "الكود",
  "Collected": "اتحصّل",
  "Collected at branch": "اتحصّل في الفرع",
  "Come back here to submit or confirm completion.": "ارجع هنا عشان تبعت النتيجة أو تأكد الإتمام.",
  "Comment": "التعليق",
  "Comment (Optional)": "التعليق (اختياري)",
  "Comment posted": "التعليق اتضاف",
  "Comments": "التعليقات",
  "Comments & Notes": "التعليقات والملاحظات",
  "Compact": "مختصر",
  "Complete demand": "الطلب الكامل",
  "Complete the three required session checks.": "كمّل التلات مراجعات المطلوبة للحصة.",
  "Completed": "مكتمل",
  "Completed attempts": "المحاولات المكتملة",
  "Completed correctly": "اتعملت صح",
  "Completed course": "كورس مكتمل",
  "Completed groups": "المجموعات المكتملة",
  "Comprehension": "فهم المقروء",
  "Confirm": "تأكيد",
  "Confirm Cancel": "تأكيد الإلغاء",
  "Confirm Reject": "تأكيد الرفض",
  "Confirmed walk-in": "زيارة مؤكدة",
  "Consult Queue": "طابور الاستشارات",
  "Consultation": "الاستشارة",
  "Contact Corrections": "تصحيح بيانات التواصل",
  "Contact Information": "بيانات التواصل",
  "Converted": "اتحوّل",
  "Copy host link": "نسخ لينك المضيف",
  "Correct": "صح",
  "Cost Center": "مركز التكلفة",
  "Cost Center *": "مركز التكلفة *",
  "Cost Centers": "مراكز التكلفة",
  "Could not create the combined certificate PDF. Please try again.": "ما قدرناش نعمل ملف PDF المجمّع للشهادات. جرّب تاني.",
  "Could not fetch job status": "ما قدرناش نجيب حالة المهمة",
  "Could not load comments.": "ما قدرناش نحمّل التعليقات.",
  "Could not load folders": "ما قدرناش نحمّل المجلدات",
  "Could not load registered students": "ما قدرناش نحمّل الطلاب المسجلين",
  "Could not load reports": "ما قدرناش نحمّل التقارير",
  "Could not load reviews": "ما قدرناش نحمّل المراجعات",
  "Could not load tasks": "ما قدرناش نحمّل المهام",
  "Could not load today's groups": "ما قدرناش نحمّل مجموعات النهارده",
  "Could not load waiting insights": "ما قدرناش نحمّل تحليلات الانتظار",
  "Could not open task": "ما قدرناش نفتح المهمة",
  "Count": "العدد",
  "Coupon Code": "كود الكوبون",
  "Coupons": "الكوبونات",
  "Course": "الكورس",
  "Course / program": "الكورس / البرنامج",
  "Course Agreed Price": "سعر الكورس المتفق عليه",
  "Course catalog": "كتالوج الكورسات",
  "Course filter": "فلتر الكورس",
  "Course interest work": "متابعة الاهتمام بالكورس",
  "Course Interests": "الاهتمام بالكورسات",
  "Course Interests Management": "إدارة الاهتمام بالكورسات",
  "Course name": "اسم الكورس",
  "Course Name *": "اسم الكورس *",
  "Course Name is required": "اسم الكورس مطلوب",
  "Course name, branch, type...": "اسم الكورس، الفرع، النوع...",
  "Course Payment": "دفعة الكورس",
  "Course Payments": "مدفوعات الكورس",
  "Course Remaining": "باقي الكورس",
  "Course Revenue": "إيرادات الكورس",
  "Course track": "مسار الكورس",
  "Course Type": "نوع الكورس",
  "Course Waivers (Non-cash)": "إعفاءات الكورس (غير نقدية)",
  "Course, place, date, time, and type are required": "الكورس والمكان والتاريخ والوقت والنوع مطلوبين",
  "Covered": "متغطّي",
  "Create Draft Group": "إنشاء مجموعة مسودة",
  "Create Exam": "إنشاء امتحان",
  "Create group": "إنشاء مجموعة",
  "Create Group from Suggestion": "إنشاء مجموعة من الاقتراح",
  "Create New Coupon": "إنشاء كوبون جديد",
  "Create New Folder": "إنشاء مجلد جديد",
  "Create New Group": "إنشاء مجموعة جديدة",
  "Create New Session": "إنشاء حصة جديدة",
  "Create New Task": "إنشاء مهمة جديدة",
  "Create New Training Group": "إنشاء مجموعة تدريب جديدة",
  "Create Schedule": "إنشاء جدول",
  "Create Session": "إنشاء حصة",
  "Created": "اتعمل",
  "Created By": "عمله",
  "Created Date": "تاريخ الإنشاء",
  "Created Exam": "الامتحان اللي اتعمل",
  "Created Student": "الطالب اللي اتسجل",
  "Created today": "اتعمل النهارده",
  "Created Within": "اتعمل خلال",
  "Creating Schedule...": "جاري إنشاء الجدول...",
  "Critical follow-up": "متابعة ضرورية",
  "Current Capacity": "السعة الحالية",
  "Current course": "الكورس الحالي",
  "Current courses": "الكورسات الحالية",
  "Current Groups": "المجموعات الحالية",
  "Current Job": "الوظيفة الحالية",
  "Current job required": "الوظيفة الحالية مطلوبة",
  "Current month": "الشهر الحالي",
  "Current placement tests": "اختبارات تحديد المستوى الحالية",
  "Current position": "الوضع الحالي",
  "Current Stage": "المرحلة الحالية",
  "Currently active": "نشط حاليًا",
  "Currently running": "شغّال حاليًا",
  "Currently working": "شغّال دلوقتي",
  "Custom amount": "مبلغ مخصص",
  "Custom course": "كورس مخصص",
  "Custom Date": "تاريخ مخصص",
  "Custom Range": "فترة مخصصة",
  "Custom Task": "مهمة مخصصة",
  "Daily Reports": "التقارير اليومية",
  "Daily Session Checklist": "قائمة مراجعة الحصة اليومية",
  "Daily Session Followup": "متابعة الحصة اليومية",
  "Daily Summary": "ملخص اليوم",
  "Daily Trend": "المتابعة اليومية",
  "Danger": "خطر",
  "Danger Days": "أيام الخطر",
  "Danger Level": "مستوى الخطر",
  "Danger Min Fill": "الحد الأدنى للإشغال عند الخطر",
  "Danger Zone": "منطقة الخطر",
  "Dashboard": "لوحة المتابعة",
  "Date": "التاريخ",
  "Date / Time": "التاريخ / الوقت",
  "Date & Time": "التاريخ والوقت",
  "Date of Birth": "تاريخ الميلاد",
  "Date Range": "الفترة",
  "Days": "الأيام",
  "Days Between Payments": "الأيام بين الدفعات",
  "Deactivate": "إيقاف التفعيل",
  "Declined": "مرفوض",
  "Declined requests": "الطلبات المرفوضة",
  "Default": "الافتراضي",
  "Defaults to your reception branch": "الافتراضي هو فرع الريسبشن بتاعك",
  "Delete": "حذف",
  "Delete comment?": "تحذف التعليق؟",
  "Delete Consultation Slot": "حذف ميعاد الاستشارة",
  "Delete failed": "الحذف ما تمّش",
  "Delete material": "حذف المادة",
  "Delete section": "حذف القسم",
  "Delete Slot": "حذف الميعاد",
  "Delete Student": "حذف الطالب",
  "Delete task": "حذف المهمة",
  "Delete this attempt?": "تحذف المحاولة دي؟",
  "Deleting this slot can affect leads who already selected it. Consider deactivating instead when possible.": "حذف الميعاد ممكن يأثر على العملاء اللي اختاروه. الأفضل توقف تفعيله لو ده متاح.",
  "Delivery approval reason": "سبب الموافقة على طريقة الحضور",
  "Desc": "تنازلي",
  "Describe what you did, the result, and any notes super reception should see...": "اكتب اللي عملته والنتيجة وأي ملاحظات مسؤول الريسبشن محتاج يشوفها...",
  "Description": "الوصف",
  "Description is required": "الوصف مطلوب",
  "Destination branch": "الفرع المستهدف",
  "Detailed student payment tracking · All amounts in EGP": "متابعة تفصيلية لمدفوعات الطلاب · كل المبالغ بالجنيه المصري",
  "Details": "التفاصيل",
  "Did Not Complete": "ما كملش",
  "Disabled exam": "امتحان متوقف",
  "Discard the unsaved import target and callback settings?": "تسيب بيانات الاستيراد وإعدادات استقبال النتيجة اللي ما اتحفظتش؟",
  "Discount Type": "نوع الخصم",
  "Discount Value": "قيمة الخصم",
  "Dismiss": "قفل",
  "Done": "تمت",
  "Done tasks": "المهام اللي خلصت",
  "Done Wrong": "اتعملت غلط",
  "Drag & drop your files here": "اسحب الملفات وسيبها هنا",
  "Drag to reorder": "اسحب لتغيير الترتيب",
  "Due": "مستحق",
  "Due / Active": "مستحق / نشط",
  "Due Date": "تاريخ الاستحقاق",
  "Duration": "المدة",
  "Duration (min)": "المدة (دقيقة)",
  "Edit": "تعديل",
  "Edit Exam": "تعديل الامتحان",
  "Edit form": "تعديل النموذج",
  "Edit Group": "تعديل المجموعة",
  "Edit pending super reception approval.": "التعديل مستني موافقة مسؤول الريسبشن.",
  "Edit program": "تعديل البرنامج",
  "Edit Sales Invoice": "تعديل فاتورة المبيعات",
  "Edit Score": "تعديل الدرجة",
  "Edit Section": "تعديل القسم",
  "Edit session link": "تعديل لينك الحصة",
  "Edit Slot": "تعديل الميعاد",
  "Edit task": "تعديل المهمة",
  "Edit the exam and set exactly one correct option for MCQs.": "عدّل الامتحان وحدد إجابة صحيحة واحدة بس لكل سؤال اختيار من متعدد.",
  "Educational Qualification": "المؤهل الدراسي",
  "EGP": "ج.م",
  "Email": "الإيميل",
  "Email Delivery": "إرسال بالإيميل",
  "Employee": "الموظف",
  "Employee Folders": "مجلدات الموظفين",
  "Employee ID": "رقم الموظف",
  "Employee Records": "سجلات الموظفين",
  "Employee Task Folders": "مجلدات مهام الموظفين",
  "End": "نهاية",
  "End Date": "تاريخ النهاية",
  "End Time": "وقت النهاية",
  "End time must be after start time": "وقت النهاية لازم يكون بعد وقت البداية",
  "English": "الإنجليزي",
  "English exams": "امتحانات الإنجليزي",
  "English Language": "اللغة الإنجليزية",
  "English material": "مادة إنجليزي",
  "English materials": "مواد الإنجليزي",
  "Enter a short reason for revocation.": "اكتب سبب مختصر لإلغاء الشهادة.",
  "Enter amount": "اكتب المبلغ",
  "Enter amount in Egyptian Pounds": "اكتب المبلغ بالجنيه المصري",
  "Enter expense description": "اكتب وصف المصروف",
  "Enter income description": "اكتب وصف الإيراد",
  "Enter reason for rejection...": "اكتب سبب الرفض...",
  "Enter the attendance grade.": "اكتب درجة الحضور.",
  "Enter the CEO name.": "اكتب اسم المدير التنفيذي.",
  "Enter the certificate title.": "اكتب عنوان الشهادة.",
  "Enter the course or program name.": "اكتب اسم الكورس أو البرنامج.",
  "Enter the exam grade.": "اكتب درجة الامتحان.",
  "Enter the final grade.": "اكتب الدرجة النهائية.",
  "Enter the participation grade.": "اكتب درجة المشاركة.",
  "Enter the recipient name.": "اكتب اسم صاحب الشهادة.",
  "Enter the total hours.": "اكتب إجمالي الساعات.",
  "Enter the trainer name.": "اكتب اسم المدرب.",
  "Entries": "السجلات",
  "Entry": "السجل",
  "Entry to request for void": "السجل المطلوب إلغاؤه",
  "Entry to void": "السجل اللي هيتلغي",
  "Equal": "يساوي",
  "Error Loading Groups": "حصل خطأ في تحميل المجموعات",
  "Error Loading Logs": "حصل خطأ في تحميل السجلات",
  "Error Loading Matrix": "حصل خطأ في تحميل جدول الحضور",
  "Error Loading Session": "حصل خطأ في تحميل الحصة",
  "Error": "خطأ",
  "Essay / paragraph": "مقال / فقرة",
  "Every attendance mark": "كل علامات الحضور",
  "Every course": "كل الكورسات",
  "Every exam type": "كل أنواع الامتحانات",
  "Every group": "كل المجموعات",
  "Every language": "كل اللغات",
  "Every loaded group": "كل المجموعات اللي اتحملت",
  "Every payment type": "كل أنواع الدفع",
  "Every status": "كل الحالات",
  "Every task type": "كل أنواع المهام",
  "Evidence": "دليل التحقق",
  "Evidence (at least 10 characters)": "دليل التحقق (10 حروف على الأقل)",
  "Exact match": "تطابق تام",
  "Exam": "الامتحان",
  "Exam Attempt": "محاولة الامتحان",
  "Exam Audit": "مراجعة الامتحان",
  "Exam Library": "مكتبة الامتحانات",
  "Exam Metadata": "بيانات الامتحان",
  "Exam pages": "صفحات الامتحان",
  "Exam Readiness": "جاهزية الامتحان",
  "Exam Score": "درجة الامتحان",
  "Exam Submitted": "الامتحان اتبعت",
  "Exam Summary": "ملخص الامتحان",
  "Exam Type": "نوع الامتحان",
  "Exams": "الامتحانات",
  "Excused": "بعذر",
  "Existing Balance": "الرصيد الحالي",
  "Existing Groups": "المجموعات الحالية",
  "Expense": "المصروف",
  "Expense Breakdown by Payment Method": "تفصيل المصروفات حسب طريقة الدفع",
  "Expense category": "تصنيف المصروف",
  "Expense payment method": "طريقة دفع المصروف",
  "Expense period": "فترة المصروف",
  "Expense status": "حالة المصروف",
  "Expenses": "المصروفات",
  "Expired": "انتهت صلاحيته",
  "Explain the refund reason (at least 20 characters)...": "اكتب سبب الاسترداد (20 حرف على الأقل)...",
  "Explain why this certificate must be revoked": "اكتب سبب إلغاء الشهادة",
  "Explain why this interest is rejected...": "اكتب سبب رفض الاهتمام بالكورس...",
  "Explain why this payment cancellation is requested...": "اكتب سبب طلب إلغاء الدفعة...",
  "Explanation": "الشرح",
  "Export": "تصدير",
  "Export CSV": "تصدير CSV",
  "Export Customer Identity Audit": "تصدير مراجعة هوية العملاء",
  "Export groups and reconciliation report": "تصدير المجموعات وتقرير مطابقة البيانات",
  "Export invoices": "تصدير الفواتير",
  "Export students": "تصدير الطلاب",
  "Export visible": "تصدير الظاهر",
  "External ID / learner code (optional)": "رقم خارجي / كود المتعلم (اختياري)",
  "External learning URL": "لينك التعلم الخارجي",
  "External material": "مادة خارجية",
  "Faculty": "الكلية",
  "Feedback": "الملاحظات",
  "Fees (EGP)": "الرسوم (ج.م)",
  "Female": "أنثى",
  "Field label": "اسم الحقل",
  "Field Type": "نوع الحقل",
  "Fill": "الإشغال",
  "Filter by title...": "فلتر بالعنوان...",
  "Filter Materials": "فلترة المواد",
  "Filter Tasks": "فلترة المهام",
  "Filter Training Type": "فلتر نوع التدريب",
  "Filters": "الفلاتر",
  "Final grade": "الدرجة النهائية",
  "Finance Command Center": "مركز متابعة الحسابات",
  "Finance Dashboard": "لوحة الحسابات",
  "Finance data is partially unavailable right now. Please refresh in a moment.": "جزء من بيانات الحسابات مش متاح دلوقتي. حدّث الصفحة بعد شوية.",
  "Finance Report": "تقرير الحسابات",
  "Finance task": "مهمة حسابات",
  "Finish student course": "إنهاء كورس الطالب",
  "Finished": "خلص",
  "Finished degree": "أتم المؤهل",
  "Finished groups": "المجموعات اللي خلصت",
  "Finished Students": "الطلاب اللي خلصوا",
  "First invoice also approves the student automatically.": "أول فاتورة بتعتمد الطالب تلقائيًا كمان.",
  "First invoice approves student": "أول فاتورة بتعتمد الطالب",
  "Folder": "المجلد",
  "Folder name": "اسم المجلد",
  "Form Status": "حالة النموذج",
  "Form Title": "عنوان النموذج",
  "Forms": "النماذج",
  "Free Additional Service": "خدمة إضافية مجانية",
  "Free of Charge": "بدون رسوم",
  "Free of Charge details": "تفاصيل الإعفاء من الرسوم",
  "Free Offer": "عرض مجاني",
  "Free Session": "حصة مجانية",
  "From": "من",
  "From date": "من تاريخ",
  "Full Name (4 parts)": "الاسم الرباعي",
  "Full page": "صفحة كاملة",
  "Full timeline": "السجل الكامل",
  "Future sessions": "الحصص الجاية",
  "Gender": "النوع",
  "General consult": "استشارة عامة",
  "General note": "ملاحظة عامة",
  "Generate Finance Report": "إنشاء تقرير حسابات",
  "Generate Installments": "إنشاء الأقساط",
  "Generated automatically": "بيتعمل تلقائيًا",
  "German": "الألماني",
  "German exams": "امتحانات الألماني",
  "German Language": "اللغة الألمانية",
  "German material": "مادة ألماني",
  "German materials": "مواد الألماني",
  "Graduate": "خريج",
  "Greater or equal": "أكبر من أو يساوي",
  "Group": "المجموعة",
  "Group Attendance": "حضور المجموعة",
  "Group based material": "مادة خاصة بالمجموعة",
  "Group Basics": "بيانات المجموعة الأساسية",
  "Group Code": "كود المجموعة",
  "Group code, name or course": "كود المجموعة أو الاسم أو الكورس",
  "Group Delivery Mode": "طريقة حضور المجموعة",
  "Group details": "تفاصيل المجموعة",
  "Group Follow-up": "متابعة المجموعة",
  "Group Follow-up Rows": "سجلات متابعة المجموعة",
  "Group Followup": "متابعة المجموعة",
  "Group for delivery approval": "مجموعة الموافقة على الحضور",
  "Group ID": "رقم المجموعة",
  "Group Join Requests": "طلبات الانضمام للمجموعات",
  "Group Matrix": "جدول المجموعة",
  "Group Membership": "عضوية المجموعة",
  "Receipt design selector": "اختيار تصميم الإيصال",
  "Sending email receipt...": "جارٍ إرسال الإيصال بالبريد الإلكتروني...",
  "Email receipt was already sent": "سبق إرسال الإيصال بالبريد الإلكتروني",
  "Email receipt sent": "تم إرسال الإيصال بالبريد الإلكتروني",
  "Receipt delivery failed": "تعذّر إرسال الإيصال",
  "Design 1": "التصميم الأول",
  "Design 2": "التصميم الثاني",
  "Group Memberships": "عضوية المجموعات",
  "Group Name": "اسم المجموعة",
  "Group name or code...": "اسم المجموعة أو الكود...",
  "Group registration": "تسجيل المجموعة",
  "Group selection": "اختيار المجموعة",
  "Group Status": "حالة المجموعة",
  "Group View": "عرض المجموعة",
  "Groups": "المجموعات",
  "Groups Management": "إدارة المجموعات",
  "Groups Working on": "المجموعات الجاري العمل عليها",
  "Guest Name": "اسم الضيف",
  "Guest name, phone, email...": "اسم الضيف، التليفون، الإيميل...",
  "Has Note": "فيه ملاحظة",
  "Hidden": "مخفي",
  "Hidden from leads": "مخفي عن العملاء المحتملين",
  "Hide Login/Logout": "إخفاء تسجيل الدخول والخروج",
  "High": "عالي",
  "High Priority": "أولوية عالية",
  "Historical record; details show the latest saved values.": "سجل قديم؛ التفاصيل بتعرض آخر قيم محفوظة.",
  "History": "السجل",
  "How to complete": "إزاي تكمّل",
  "How to Fix": "إزاي تصلّح",
  "Hybrid": "مختلط",
  "ID": "الرقم",
  "ID Type": "نوع إثبات الهوية",
  "Immediate action": "إجراء فوري",
  "Immediate attention": "محتاج اهتمام فورًا",
  "Import": "استيراد",
  "Import Exam": "استيراد امتحان",
  "Import Exam with AI": "استيراد امتحان بالذكاء الاصطناعي",
  "Import Job": "مهمة الاستيراد",
  "Import job status is unavailable": "حالة مهمة الاستيراد مش متاحة",
  "Import Progress": "متابعة الاستيراد",
  "Import Readiness": "جاهزية الاستيراد",
  "Import request failed": "طلب الاستيراد ما تمّش",
  "In Progress": "جاري التنفيذ",
  "in queue": "في الطابور",
  "In-person": "حضوري",
  "Inactive": "غير نشط",
  "Inactive Students": "الطلاب غير النشطين",
  "Income Breakdown by Payment Method": "تفصيل الإيرادات حسب طريقة الدفع",
  "Income category": "تصنيف الإيراد",
  "Incorrect": "غلط",
  "Info": "معلومات",
  "Installment Checked": "القسط اتراجع",
  "Installment Schedule": "جدول الأقساط",
  "Installments": "الأقساط",
  "Installments Schedule": "جدول الأقساط",
  "Instant transfer": "تحويل فوري",
  "Instapay": "إنستاباي",
  "Instructions": "التعليمات",
  "Instructions shown to the student...": "التعليمات اللي هتظهر للطالب...",
  "Instructor": "المدرب",
  "Interest converted to a group request": "الاهتمام اتحوّل لطلب مجموعة",
  "Interest Details": "تفاصيل الاهتمام بالكورس",
  "Interest Filters": "فلاتر الاهتمام بالكورس",
  "Interest rejected": "الاهتمام اترفض",
  "Internal note": "ملاحظة داخلية",
  "Internal note (optional)": "ملاحظة داخلية (اختياري)",
  "Internal only": "داخلي بس",
  "Invoice": "الفاتورة",
  "Invoice Comment": "تعليق الفاتورة",
  "Invoice created": "الفاتورة اتعملت",
  "Invoice not found.": "الفاتورة مش موجودة.",
  "Invoices": "الفواتير",
  "Issue certificate": "إصدار شهادة",
  "Issue Invoice": "إصدار فاتورة",
  "Issue Student Invoice": "إصدار فاتورة طالب",
  "Issue the first certificate from the button above.": "اصدر أول شهادة من الزر اللي فوق.",
  "Issued": "اتصدر",
  "Issued by": "أصدره",
  "Item Type": "نوع البند",
  "Join as viewer": "انضمام كمشاهد",
  "Join request approved": "طلب الانضمام اتوافق عليه",
  "Join request rejected": "طلب الانضمام اترفض",
  "Join request work": "متابعة طلب الانضمام",
  "Join Requests": "طلبات الانضمام",
  "Keep Session": "الإبقاء على الحصة",
  "Key": "المفتاح",
  "Language": "اللغة",
  "Language Center": "مركز اللغات",
  "Language exams": "امتحانات اللغات",
  "Language filter": "فلتر اللغة",
  "Language level": "مستوى اللغة",
  "Language level and group scopes cannot be combined.": "ما ينفعش تجمع نطاق مستوى اللغة والمجموعة.",
  "Language Package Renewal": "تجديد باقة اللغة",
  "Language program completed": "برنامج اللغة اكتمل",
  "Language Progress & Package": "تقدم اللغة والباقة",
  "Language Progression": "التدرج في مستويات اللغة",
  "Languages use level folders": "اللغات بتستخدم مجلدات المستويات",
  "Large": "كبير",
  "Large batch": "دفعة كبيرة",
  "Large list": "قائمة كبيرة",
  "Large page": "صفحة كبيرة",
  "Large queue": "طابور كبير",
  "Last 30 days": "آخر 30 يوم",
  "Last 7 days": "آخر 7 أيام",
  "Last 90 days": "آخر 90 يوم",
  "Late": "متأخر",
  "Late records": "السجلات المتأخرة",
  "Latest Registrations": "آخر التسجيلات",
  "Lead Name": "اسم العميل المحتمل",
  "Lead name, phone, course...": "اسم العميل المحتمل، التليفون، الكورس...",
  "Learning files": "ملفات التعلم",
  "Leave empty to use the group default.": "سيبه فاضي لاستخدام الإعداد الافتراضي للمجموعة.",
  "Legacy/unspecified package": "باقة قديمة / مش محددة",
  "Less than": "أقل من",
  "Let AI classify questions": "خلي الذكاء الاصطناعي يصنف الأسئلة",
  "Level": "المستوى",
  "Level / Group": "المستوى / المجموعة",
  "Level assessment": "تقييم المستوى",
  "Level Exam": "امتحان المستوى",
  "Level Exam Attempts": "محاولات امتحان المستوى",
  "Level progression is automatic when moving to the next language level group.": "المستوى بيتقدم تلقائيًا عند الانتقال لمجموعة مستوى اللغة اللي بعده.",
  "Level-based": "حسب المستوى",
  "levels consumed": "المستويات المستخدمة",
  "Link": "لينك",
  "Link Group to Registration": "ربط المجموعة بالتسجيل",
  "Link original invoices": "ربط الفواتير الأصلية",
  "Linked Session": "الحصة المرتبطة",
  "Links & Communication": "اللينكات والتواصل",
  "Listening": "استماع",
  "Listening Audio": "مقطع الاستماع",
  "Listening prompts manual audio": "مقاطع الاستماع محتاجة رفع صوت يدوي",
  "Live": "مباشر",
  "Load Materials": "تحميل المواد",
  "Load older actions": "تحميل الإجراءات الأقدم",
  "Loading...": "جاري التحميل...",
  "Log Information": "بيانات السجل",
  "Logged": "اتسجل",
  "Low": "منخفض",
  "Lower or equal": "أقل من أو يساوي",
  "Main course invoice": "فاتورة الكورس الأساسية",
  "Male": "ذكر",
  "Manage All": "إدارة الكل",
  "Manager Insights": "تحليلات المدير",
  "Manual": "يدوي",
  "Manual builder": "إنشاء يدوي",
  "Manual custom task": "مهمة يدوية مخصصة",
  "Manual Date": "تاريخ يدوي",
  "Manual grading": "تصحيح يدوي",
  "Manual reception task": "مهمة ريسبشن يدوية",
  "Manual recipient": "صاحب شهادة يدوي",
  "Manual Score Correction": "تصحيح الدرجة يدويًا",
  "Manual transfer": "تحويل يدوي",
  "Manual work reviewed by super": "شغل يدوي بيراجعه مسؤول الريسبشن",
  "Mark": "تسجيل",
  "Mark Course Finished": "تسجيل الكورس كمكتمل",
  "Mark Overdue": "تسجيل كمتأخر",
  "Mark Student Waiting": "نقل الطالب للانتظار",
  "Mark this installment as overdue and notify the student?": "تسجل القسط ده كمتأخر وتبلّغ الطالب؟",
  "marked absent": "اتسجل غايب",
  "Marked present": "اتسجل حاضر",
  "Marketing": "التسويق",
  "Material Categorization": "تصنيف المواد",
  "Material folder": "مجلد المادة",
  "Material Title": "عنوان المادة",
  "Material Type": "نوع المادة",
  "Materials": "المواد",
  "Materials Management": "إدارة المواد",
  "Matrix": "جدول الحضور",
  "Matrix Filters": "فلاتر جدول الحضور",
  "Matrix route is unavailable in Manager": "صفحة جدول الحضور مش متاحة في الإدارة",
  "Matrix View": "عرض جدول الحضور",
  "Matrix view is available in Reception only": "عرض جدول الحضور متاح في الريسبشن بس",
  "Max Seconds": "أقصى عدد ثواني",
  "Max Students": "أقصى عدد طلاب",
  "Max Uses": "أقصى عدد مرات استخدام",
  "Maximum Capacity": "السعة القصوى",
  "MCQ": "اختيار من متعدد",
  "MCQ only": "اختيار من متعدد بس",
  "MCQs": "أسئلة اختيار من متعدد",
  "Medium": "متوسط",
  "Meeting Link": "لينك الاجتماع",
  "Meeting link saved": "لينك الاجتماع اتحفظ",
  "Meeting Type": "نوع الاجتماع",
  "Meeting URL": "لينك الاجتماع",
  "Mentor": "الموجّه",
  "Message": "الرسالة",
  "Metadata": "البيانات الإضافية",
  "Method": "الطريقة",
  "min": "دقيقة",
  "Missing Follow-up": "متابعة ناقصة",
  "Missing job id": "رقم المهمة مش موجود",
  "Mobile wallet": "محفظة موبايل",
  "Model Answer": "الإجابة النموذجية",
  "Month": "الشهر",
  "Monthly Demand": "الطلب الشهري",
  "Monthly tasks": "المهام الشهرية",
  "More Details": "تفاصيل أكتر",
  "more fields": "حقول إضافية",
  "More Filters": "فلاتر أكتر",
  "more pending": "طلبات معلّقة إضافية",
  "More records": "سجلات أكتر",
  "More rows": "صفوف أكتر",
  "more sessions": "حصص إضافية",
  "More than": "أكتر من",
  "Move": "نقل",
  "Move Selected To Folder": "نقل المحدد لمجلد",
  "Move student": "نقل طالب",
  "Moved to group flow": "اتنقل لمسار المجموعة",
  "Multi-file support": "دعم ملفات متعددة",
  "Multiple choice questions": "أسئلة اختيار من متعدد",
  "My Tasks": "مهامي",
  "Name": "الاسم",
  "National ID": "الرقم القومي",
  "Need follow-up": "محتاج متابعة",
  "Need scheduling": "محتاج جدولة",
  "Needs action": "محتاج إجراء",
  "Needs attention": "محتاج اهتمام",
  "Needs follow-up": "محتاج متابعة",
  "Needs Group": "محتاج مجموعة",
  "Needs instructor": "محتاج مدرب",
  "Needs matching": "محتاج مطابقة",
  "Needs reception decision": "محتاج قرار من الريسبشن",
  "Needs Review": "محتاج مراجعة",
  "Net": "الصافي",
  "Net Total": "الإجمالي الصافي",
  "Network error marking overdue": "حصل خطأ في الاتصال أثناء تسجيل التأخير",
  "Network error processing payment": "حصل خطأ في الاتصال أثناء تسجيل الدفعة",
  "New approved records will appear here.": "السجلات المعتمدة الجديدة هتظهر هنا.",
  "New Course Price (Total)": "سعر الكورس الجديد (الإجمالي)",
  "New entries will appear here once recorded.": "السجلات الجديدة هتظهر هنا بعد تسجيلها.",
  "New Invoice Details": "تفاصيل الفاتورة الجديدة",
  "New official record": "سجل رسمي جديد",
  "New Registration Branch": "فرع التسجيل الجديد",
  "New Remaining": "الباقي الجديد",
  "New Sales Invoice": "فاتورة مبيعات جديدة",
  "New Session": "حصة جديدة",
  "New student comment": "تعليق طالب جديد",
  "New submissions": "تسجيلات جديدة",
  "New total amount": "المبلغ الإجمالي الجديد",
  "New Total Price (EGP)": "السعر الإجمالي الجديد (ج.م)",
  "Newest first": "الأحدث الأول",
  "Next": "التالي",
  "Next level": "المستوى التالي",
  "Next Month": "الشهر الجاي",
  "Next Sessions": "الحصص الجاية",
  "No": "لا",
  "None": "مفيش",
  "Normal activity": "نشاط عادي",
  "Normal priority": "أولوية عادية",
  "Normal task": "مهمة عادية",
  "Not answered": "ما اتجاوبش",
  "Not assigned": "مش متعيّن",
  "Not found": "مش موجود",
  "Not Provided": "مش متسجل",
  "Not Started": "لسه ما بدأش",
  "Not Verified": "مش متحقق منه",
  "Not Yet": "لسه",
  "Note": "الملاحظة",
  "Note (optional)": "ملاحظة (اختياري)",
  "Notes": "الملاحظات",
  "Notes (Optional)": "ملاحظات (اختياري)",
  "Notes for Accountant": "ملاحظات للمحاسب",
  "Notified": "اتبلّغ",
  "Notify": "إبلاغ",
  "Notify Student": "إبلاغ الطالب",
  "Number of Installments": "عدد الأقساط",
  "Off means signed-in eligible students only.": "لو مقفول، متاح للطلاب المؤهلين المسجلين دخولهم بس.",
  "Official #": "رقم رسمي",
  "Offline": "حضوري",
  "Offline and online": "حضوري وأونلاين",
  "Offline Branches / فروع الأوفلاين": "الفروع الحضورية",
  "Oldest first": "الأقدم الأول",
  "One-to-one consult": "استشارة فردية",
  "Online": "أونلاين",
  "Online only": "أونلاين بس",
  "Open": "فتح",
  "Open attendance": "فتح الحضور",
  "Open Detail": "فتح التفاصيل",
  "Open external link": "فتح اللينك الخارجي",
  "Open file": "فتح الملف",
  "Open Interests": "فتح الاهتمام بالكورسات",
  "Open Link": "فتح اللينك",
  "Open My Tasks": "فتح مهامي",
  "Open receipt": "فتح الإيصال",
  "Open supporting document": "فتح المستند الداعم",
  "Open Waiting List": "فتح قائمة الانتظار",
  "Opening live import channel...": "جاري فتح متابعة الاستيراد المباشرة...",
  "Option text": "نص الاختيار",
  "Optional - leave empty to keep same": "اختياري - سيبه فاضي عشان يفضل زي ما هو",
  "Optional answer explanation...": "شرح الإجابة (اختياري)...",
  "Optional branch scope": "نطاق الفرع (اختياري)",
  "Optional comment for this invoice...": "تعليق للفاتورة (اختياري)...",
  "Optional model answer...": "إجابة نموذجية (اختياري)...",
  "Optional note for the new group...": "ملاحظة للمجموعة الجديدة (اختياري)...",
  "Optional note for this notification...": "ملاحظة للإبلاغ ده (اختياري)...",
  "Optional note...": "ملاحظة (اختياري)...",
  "Options": "الاختيارات",
  "Options separated by comma": "اختيارات مفصولة بفاصلة",
  "or click to browse files": "أو اضغط لاختيار الملفات",
  "Oral prompt": "سؤال شفوي",
  "Order": "الترتيب",
  "Organize Existing Materials": "تنظيم المواد الحالية",
  "Organize folders": "تنظيم المجلدات",
  "Original invoice items": "بنود الفاتورة الأصلية",
  "Original invoice linking": "ربط الفاتورة الأصلية",
  "Original invoices linked": "الفواتير الأصلية اتربطت",
  "Original receipt": "الإيصال الأصلي",
  "Other": "أخرى",
  "Other (custom)": "أخرى (مخصص)",
  "Other Courses": "الكورسات التانية",
  "Overdue": "متأخر",
  "Overdue Installments": "الأقساط المتأخرة",
  "Overview": "نظرة عامة",
  "Ownership & Delivery": "المسؤولية وطريقة الحضور",
  "Page": "الصفحة",
  "Paid": "مدفوع",
  "Paid Amount": "المبلغ المدفوع",
  "Paid consultation": "استشارة مدفوعة",
  "Paid Date": "تاريخ الدفع",
  "Paid Invoice": "فاتورة مدفوعة",
  "Paid Now": "المدفوع دلوقتي",
  "Paid Session": "حصة مدفوعة",
  "Partial amount (leave empty for full amount)": "مبلغ جزئي (سيبه فاضي للمبلغ الكامل)",
  "Participation": "المشاركة",
  "Passage": "القطعة",
  "Passage + questions": "قطعة + أسئلة",
  "Passage-based questions": "أسئلة على قطعة",
  "Passport": "جواز سفر",
  "Passport holder": "صاحب جواز سفر",
  "Passport number": "رقم جواز السفر",
  "Password Setup": "إعداد كلمة السر",
  "Past sessions": "الحصص السابقة",
  "Paste the session Zoom link": "حط لينك زووم للحصة",
  "Payment": "الدفعة",
  "Payment Amount (EGP)": "مبلغ الدفعة (ج.م)",
  "Payment and invoice": "الدفعة والفاتورة",
  "Payment approved": "الدفعة اتوافق عليها",
  "Payment Details": "تفاصيل الدفعة",
  "Payment Filters": "فلاتر الدفع",
  "Payment History": "سجل المدفوعات",
  "Payment method": "طريقة الدفع",
  "Payment Method *": "طريقة الدفع *",
  "Payment Pending": "مستني الدفع",
  "Payment Pending Students": "طلاب مستنيين الدفع",
  "Payment Purpose": "غرض الدفع",
  "Payment recorded": "الدفعة اتسجلت",
  "Payment rejected": "الدفعة اترفضت",
  "Payment Review": "مراجعة الدفعة",
  "Payment Schedule": "جدول الدفع",
  "Payment Transactions": "معاملات الدفع",
  "Payments": "المدفوعات",
  "Pending": "معلّق",
  "Pending / Working": "معلّق / جاري التنفيذ",
  "Pending Amount": "المبلغ المعلّق",
  "Pending Approvals": "الموافقات المعلّقة",
  "Pending My Approval": "مستني موافقتي",
  "Pending Review": "مستني مراجعة",
  "pending selected": "طلبات معلّقة محددة",
  "Pending Work Items": "الشغل المعلّق",
  "Per Page": "لكل صفحة",
  "Period": "الفترة",
  "Personal Information": "البيانات الشخصية",
  "Phone": "التليفون",
  "Photo Description": "وصف الصورة",
  "Pick a language level or a group first": "اختار مستوى لغة أو مجموعة الأول",
  "Place": "المكان",
  "Place or time is too long": "المكان أو الوقت أطول من المسموح",
  "Placement": "تحديد المستوى",
  "Placement / level assessment": "تحديد / تقييم المستوى",
  "Placement + level": "تحديد مستوى + مستوى",
  "Placement Exam Attempts": "محاولات امتحان تحديد المستوى",
  "Placement Exams": "امتحانات تحديد المستوى",
  "Placement Payments": "مدفوعات تحديد المستوى",
  "Placement Rejection Reason": "سبب رفض تحديد المستوى",
  "Placement test": "اختبار تحديد المستوى",
  "Placement Test Payments": "مدفوعات اختبار تحديد المستوى",
  "Plan My Tasks": "تخطيط مهامي",
  "Planned": "مخطط",
  "Planned capacity exists": "فيه سعة مخططة",
  "Planned Group Alert Conditions": "شروط تنبيهات المجموعات المخططة",
  "Planned groups": "المجموعات المخططة",
  "Planning Filters": "فلاتر التخطيط",
  "Planning note": "ملاحظة التخطيط",
  "Planning Suggestions": "اقتراحات التخطيط",
  "Please enter a valid amount.": "اكتب مبلغ صحيح.",
  "Please enter a valid number of installments (1-50)": "اكتب عدد أقساط صحيح (من 1 لـ50)",
  "Please enter a valid payment amount": "اكتب مبلغ دفع صحيح",
  "Please enter a valid positive amount": "اكتب مبلغ صحيح أكبر من صفر",
  "Please enter valid days between payments (1-365)": "اكتب عدد أيام صحيح بين الدفعات (من 1 لـ365)",
  "Please explain why this entry is being voided...": "اكتب سبب إلغاء السجل ده...",
  "Please provide a summary of what you did": "اكتب ملخص اللي عملته",
  "Please save the invoice first before creating installments": "احفظ الفاتورة الأول قبل إنشاء الأقساط",
  "Please select a course.": "اختار كورس.",
  "Please select a group for course-based materials.": "اختار مجموعة لمواد الكورس.",
  "Please select a level for language courses.": "اختار مستوى لكورسات اللغة.",
  "Please select at least one file.": "اختار ملف واحد على الأقل.",
  "Please select course type and material type.": "اختار نوع الكورس ونوع المادة.",
  "PNG, JPG up to 5MB": "PNG أو JPG بحد أقصى 5MB",
  "points": "نقطة",
  "Present": "حاضر",
  "Previous": "السابق",
  "Previous Month": "الشهر اللي فات",
  "Previous Receipts": "الإيصالات السابقة",
  "Primary Actions": "الإجراءات الأساسية",
  "Print": "طباعة",
  "Print matrix": "طباعة جدول الحضور",
  "Print Receipt": "طباعة الإيصال",
  "Print report": "طباعة التقرير",
  "Printed above CEO": "مطبوع فوق المدير التنفيذي",
  "Printed above Trainer": "مطبوع فوق المدرب",
  "Priority": "الأولوية",
  "Priority Mode: Pending Danger Actions": "وضع الأولوية: إجراءات خطر مستنية الموافقة",
  "Private Meeting": "اجتماع خاص",
  "Pro Finance Dashboard": "لوحة الحسابات التفصيلية",
  "Pro Finance Reports": "تقارير الحسابات التفصيلية",
  "Processing...": "جاري التنفيذ...",
  "Program": "البرنامج",
  "Program Name": "اسم البرنامج",
  "Programs": "البرامج",
  "Progress": "التقدم",
  "Prompt-based questions": "أسئلة على تعليمات",
  "pts": "نقطة",
  "Public Alias": "الاسم العام",
  "Public guest placement test": "اختبار تحديد مستوى للضيوف",
  "Public guests": "الضيوف",
  "Public placement flow": "مسار تحديد المستوى العام",
  "Published and Draft Forms": "النماذج المنشورة والمسودات",
  "Quarter alert conditions updated": "شروط تنبيهات الدورة اتحدّثت",
  "Quarter Filters": "فلاتر الدورة",
  "Quarter Groups": "مجموعات الدورة",
  "Quarter Management": "إدارة الدورة",
  "Quarter View": "عرض الدورة",
  "Question illustration": "صورة توضيحية للسؤال",
  "Question text": "نص السؤال",
  "Question Type": "نوع السؤال",
  "Questions": "الأسئلة",
  "Queue": "الطابور",
  "Queue Filters": "فلاتر الطابور",
  "Queue status": "حالة الطابور",
  "Queue status updated": "حالة الطابور اتحدّثت",
  "Queued Leads": "العملاء في الطابور",
  "Quick Actions": "إجراءات سريعة",
  "Range": "النطاق",
  "Rate": "النسبة",
  "Rationale (optional)": "التوضيح (اختياري)",
  "Read": "اتقرا",
  "Reading Passage": "قطعة القراءة",
  "Ready": "جاهز",
  "Ready Students": "الطلاب الجاهزين",
  "Ready to submit.": "جاهز للإرسال.",
  "Real-time": "لحظي",
  "Realtime": "لحظي",
  "Reason": "السبب",
  "Reason (at least 10 characters)": "السبب (10 حروف على الأقل)",
  "Reason (at least 20 characters)": "السبب (20 حرف على الأقل)",
  "Reason (optional)": "السبب (اختياري)",
  "Reason for refund": "سبب الاسترداد",
  "Reason for rejection...": "سبب الرفض...",
  "Reason for revocation": "سبب إلغاء الشهادة",
  "Reason for score change...": "سبب تغيير الدرجة...",
  "Reason for voiding": "سبب الإلغاء",
  "Reason for voiding is required": "سبب الإلغاء مطلوب",
  "Receipt": "الإيصال",
  "Receipt file": "ملف الإيصال",
  "Receipt image": "صورة الإيصال",
  "Receipt Image (Optional)": "صورة الإيصال (اختياري)",
  "Receipt image preview": "معاينة صورة الإيصال",
  "Receipt preview": "معاينة الإيصال",
  "Receipt Proof": "إثبات الإيصال",
  "Receipt Type": "نوع الإيصال",
  "Receipts": "الإيصالات",
  "Recent Additional Income": "آخر الإيرادات الإضافية",
  "Recent Expenses": "آخر المصروفات",
  "Recent Import Jobs": "آخر عمليات الاستيراد",
  "Recent tasks": "آخر المهام",
  "reception": "الريسبشن",
  "Reception approved": "الريسبشن وافق",
  "Reception Chat": "شات الريسبشن",
  "Reception contacted": "الريسبشن اتواصل",
  "Reception note": "ملاحظة الريسبشن",
  "Reception note exists": "فيه ملاحظة من الريسبشن",
  "Reception Notes": "ملاحظات الريسبشن",
  "Reception Workspace": "مساحة عمل الريسبشن",
  "Reception-managed Consultation Slots": "مواعيد الاستشارات اللي بيديرها الريسبشن",
  "Reception-only payment comment": "تعليق دفعة خاص بالريسبشن",
  "Recipient source": "مصدر صاحب الشهادة",
  "Reconcile Registration Links": "مطابقة روابط التسجيل",
  "Record metadata": "بيانات السجل",
  "Record New Payment": "تسجيل دفعة جديدة",
  "Recorded customer payments": "مدفوعات العملاء المسجلة",
  "Recorded only": "المسجل بس",
  "Recorded payments for the selected course, net of completed refunds.": "المدفوعات المسجلة للكورس المحدد بعد خصم الاستردادات المكتملة.",
  "Recorded place": "المكان المسجل",
  "Recorded type": "النوع المسجل",
  "records": "سجلات",
  "Referral": "ترشيح",
  "Refresh": "تحديث",
  "Refresh certificates": "تحديث الشهادات",
  "Refresh Data": "تحديث البيانات",
  "Refresh finance data": "تحديث بيانات الحسابات",
  "Refresh groups": "تحديث المجموعات",
  "Refresh history": "تحديث السجل",
  "Refreshing daily reports...": "جاري تحديث التقارير اليومية...",
  "Refreshing finance data...": "جاري تحديث بيانات الحسابات...",
  "Refund": "الاسترداد",
  "Refund amount": "مبلغ الاسترداد",
  "Refund approved and forwarded to accountant": "الاسترداد اتوافق عليه واتبعت للمحاسب",
  "Refund original receipt": "إيصال الاسترداد الأصلي",
  "Refund rejected": "الاسترداد اترفض",
  "Refund Request Details": "تفاصيل طلب الاسترداد",
  "Refund request is missing": "طلب الاسترداد مش موجود",
  "Refund Requests": "طلبات الاسترداد",
  "Refunded": "اتردّ",
  "Refunded Students": "الطلاب اللي استردوا",
  "Register New Student": "تسجيل طالب جديد",
  "Register Student": "تسجيل طالب",
  "Registered": "مسجل",
  "Registered profile + password setup link.": "ملف مسجل + لينك إعداد كلمة السر.",
  "Registered profile is ready": "الملف المسجل جاهز",
  "Registered Students": "الطلاب المسجلين",
  "Registration": "التسجيل",
  "Registration and Delivery Settings": "إعدادات التسجيل وطريقة الحضور",
  "Registration Correction": "تصحيح التسجيل",
  "Registration correction reason": "سبب تصحيح التسجيل",
  "Registration Information": "بيانات التسجيل",
  "Registration Status": "حالة التسجيل",
  "Registration Status: Approved": "حالة التسجيل: معتمد",
  "Registrations": "التسجيلات",
  "Reject": "رفض",
  "Reject Interest": "رفض الاهتمام بالكورس",
  "Reject Invoice": "رفض الفاتورة",
  "Reject Payment": "رفض الدفعة",
  "Reject Refund": "رفض الاسترداد",
  "Reject Sales Invoice": "رفض فاتورة المبيعات",
  "Rejected": "مرفوض",
  "Rejected action": "الإجراء المرفوض",
  "Rejecting requires a clear reason so the salesman can correct the invoice.": "الرفض محتاج سبب واضح عشان موظف المبيعات يقدر يصحح الفاتورة.",
  "Rejecting this payment will keep the guest without placement access until corrected.": "رفض الدفعة هيمنع الضيف من دخول اختبار تحديد المستوى لحد ما تتصحح.",
  "Rejecting this request will notify the student.": "رفض الطلب هيبلّغ الطالب.",
  "Rejection reason": "سبب الرفض",
  "Rejection Reason *": "سبب الرفض *",
  "Rejection reason is required": "سبب الرفض مطلوب",
  "Rejections": "الرفض",
  "Rem": "الباقي",
  "Remaining": "الباقي",
  "Remaining balance needs an installment schedule before follow-up starts.": "المبلغ الباقي محتاج جدول أقساط قبل بدء المتابعة.",
  "Remote meeting": "اجتماع عن بُعد",
  "Remove image": "حذف الصورة",
  "Remove installment": "حذف القسط",
  "Remove student": "إزالة الطالب",
  "Renew Package": "تجديد الباقة",
  "Renewal in progress": "التجديد جاري",
  "Renewal Price": "سعر التجديد",
  "Reorder section": "تغيير ترتيب القسم",
  "Reply": "رد",
  "Report sender": "مرسل التقرير",
  "Request Cancellation": "طلب إلغاء",
  "Request Details": "تفاصيل الطلب",
  "Request note": "ملاحظة الطلب",
  "Request price change (requires super reception approval)": "طلب تغيير السعر (محتاج موافقة مسؤول الريسبشن)",
  "Request refund": "طلب استرداد",
  "Request Type": "نوع الطلب",
  "Request Void": "طلب إلغاء السجل",
  "Requested": "مطلوب",
  "Requested Group": "المجموعة المطلوبة",
  "requests": "طلبات",
  "Requests will appear here when their status changes.": "الطلبات هتظهر هنا لما حالتها تتغير.",
  "Required": "مطلوب",
  "Required for language": "مطلوب للغة",
  "Required for passport": "مطلوب لجواز السفر",
  "Requires your approval": "محتاج موافقتك",
  "Reserved": "محجوز",
  "Reset": "إعادة ضبط",
  "Reset All": "إعادة ضبط الكل",
  "Reset filters": "إعادة ضبط الفلاتر",
  "Restore": "استعادة",
  "Restore+Approve": "استعادة وموافقة",
  "Retry": "جرّب تاني",
  "Retry course list": "إعادة تحميل قائمة الكورسات",
  "Retry loading target groups": "إعادة تحميل المجموعات المستهدفة",
  "Retry student finance": "إعادة تحميل حساب الطالب",
  "Revenue": "الإيرادات",
  "Revenue Today": "إيرادات النهارده",
  "Review": "مراجعة",
  "Review \"Other\" Task Submissions": "مراجعة نتائج المهام الأخرى",
  "Review Attempts": "مراجعة المحاولات",
  "Review Comment": "تعليق المراجعة",
  "Review Free of Charge": "مراجعة الإعفاء من الرسوم",
  "Review Interest": "مراجعة الاهتمام بالكورس",
  "Review Invoice": "مراجعة الفاتورة",
  "Review Note": "ملاحظة المراجعة",
  "Review Stats": "إحصائيات المراجعة",
  "Reviewed by": "راجعه",
  "Revocation reason": "سبب إلغاء الشهادة",
  "Revoke": "إلغاء الشهادة",
  "Revoke certificate?": "تلغي الشهادة؟",
  "Room": "القاعة",
  "Rows": "الصفوف",
  "Rsvd": "محجوز",
  "Running": "جاري",
  "Running classes": "الحصص الجارية",
  "Running exam": "امتحان جاري",
  "Running Now": "شغّال دلوقتي",
  "Running today": "شغّال النهارده",
  "Sales Consultation Queue": "طابور استشارات المبيعات",
  "Sales Consultation Slots": "مواعيد استشارات المبيعات",
  "Sales Invoice Details": "تفاصيل فاتورة المبيعات",
  "Sales Payment Requests": "طلبات دفع المبيعات",
  "Save": "حفظ",
  "Save Alternate Phones": "حفظ الأرقام البديلة",
  "Save Changes": "حفظ التعديلات",
  "Save Checklist": "حفظ قائمة المراجعة",
  "Save Correction": "حفظ التصحيح",
  "Save Group Delivery Mode": "حفظ طريقة حضور المجموعة",
  "Save Link": "حفظ اللينك",
  "Save Section": "حفظ القسم",
  "Save sections structure": "حفظ ترتيب الأقسام",
  "Save service": "حفظ الخدمة",
  "Save Status": "حفظ الحالة",
  "Save structure first to upload image.": "احفظ الهيكل الأول عشان ترفع الصورة.",
  "Save Training Type": "حفظ نوع التدريب",
  "Save Verification": "حفظ التحقق",
  "Saved separately from the description.": "بيتحفظ منفصل عن الوصف.",
  "Saving": "جاري الحفظ",
  "Schedule": "الجدول",
  "Schedule Installment Payments": "جدولة دفعات الأقساط",
  "Schedule Needed": "محتاج جدولة",
  "Scheduled": "مجدول",
  "Scheduled payment": "دفعة مجدولة",
  "Score": "الدرجة",
  "Search": "بحث",
  "Search & Filter Groups": "بحث وفلترة المجموعات",
  "Search by employee, branch, or report text...": "ابحث بالموظف أو الفرع أو نص التقرير...",
  "Search by group code, program, instructor...": "ابحث بكود المجموعة أو البرنامج أو المدرب...",
  "Search by name, email, or phone...": "ابحث بالاسم أو الإيميل أو التليفون...",
  "Search by name, phone, or course...": "ابحث بالاسم أو التليفون أو الكورس...",
  "Search by student, code, or course": "ابحث بالطالب أو الكود أو الكورس",
  "Search certificates": "بحث في الشهادات",
  "Search groups by code, language, level, or instructor...": "ابحث بكود المجموعة أو اللغة أو المستوى أو المدرب...",
  "Search invoice, student, course...": "ابحث بالفاتورة أو الطالب أو الكورس...",
  "Search registered students...": "ابحث في الطلاب المسجلين...",
  "Search sessions...": "ابحث في الحصص...",
  "Search student...": "ابحث عن طالب...",
  "Search students in this group...": "ابحث عن طلاب في المجموعة دي...",
  "Search students...": "ابحث عن طلاب...",
  "Search suitable groups": "بحث عن مجموعات مناسبة",
  "Search target groups": "بحث في المجموعات المستهدفة",
  "Search ticket, student, phone...": "ابحث بالتذكرة أو الطالب أو التليفون...",
  "Searching students...": "جاري البحث عن الطلاب...",
  "Seats": "الأماكن",
  "Section": "القسم",
  "Section audio": "صوت القسم",
  "Section Title": "عنوان القسم",
  "Sections": "الأقسام",
  "Select a certificate": "اختار شهادة",
  "Select a group to view its detailed attendance matrix": "اختار مجموعة لعرض جدول حضورها بالتفصيل",
  "Select a language to choose a level.": "اختار لغة عشان تختار مستوى.",
  "Select a payment method": "اختار طريقة الدفع",
  "Select a specific group to load its students.": "اختار مجموعة محددة عشان تحمّل طلابها.",
  "Select a student from the list to view and reply to their messages": "اختار طالب من القائمة عشان تشوف رسايله وترد عليها",
  "Select at least one weekday": "اختار يوم واحد على الأقل من أيام الأسبوع",
  "Select both language and level, or leave both as All.": "اختار اللغة والمستوى مع بعض، أو سيب الاتنين على الكل.",
  "Select Branch": "اختار الفرع",
  "Select course": "اختار الكورس",
  "Select course first": "اختار الكورس الأول",
  "Select course to transfer from": "اختار الكورس اللي هتحوّل منه",
  "Select Course Type": "اختار نوع الكورس",
  "Select gender": "اختار النوع",
  "Select Level": "اختار المستوى",
  "Select level / group": "اختار المستوى / المجموعة",
  "Select payment reason": "اختار سبب الدفع",
  "Select pending on this page": "تحديد الطلبات المعلّقة في الصفحة",
  "Select qualification": "اختار المؤهل",
  "Select the course to open the invoice page with this course preselected.": "اختار الكورس عشان تفتح صفحة الفاتورة والكورس محدد فيها.",
  "Select the material file again before uploading.": "اختار ملف المادة تاني قبل الرفع.",
  "Select the receipt file again before submitting.": "اختار ملف الإيصال تاني قبل الإرسال.",
  "Select the receipt image again before submitting.": "اختار صورة الإيصال تاني قبل الإرسال.",
  "Select the source file again before continuing; file names and file contents are never stored in the navigation draft.": "اختار ملف المصدر تاني قبل ما تكمّل؛ أسماء الملفات ومحتواها مش بيتحفظوا في مسودة التنقل.",
  "Select Type": "اختار النوع",
  "Select visible": "تحديد الظاهر",
  "Select which course's payments to transfer.": "اختار الكورس اللي عايز تنقل مدفوعاته.",
  "selected": "محدد",
  "Selected At": "اتحدد في",
  "Selected certificate": "الشهادة المحددة",
  "Selected group does not have a course name. Please select a valid course group.": "المجموعة المحددة مفيهاش اسم كورس. اختار مجموعة بكورس صحيح.",
  "Selected Session": "الحصة المحددة",
  "self": "ذاتي",
  "Self Planning": "تخطيط ذاتي",
  "Self Task Approvals": "موافقات المهام الذاتية",
  "Send": "إرسال",
  "Send a message to start the conversation": "ابعت رسالة عشان تبدأ المحادثة",
  "Send Notification": "إرسال إبلاغ",
  "Send password link": "إرسال لينك كلمة السر",
  "Sensitive action": "إجراء حساس",
  "Server did not return a job id": "السيرفر ما رجّعش رقم المهمة",
  "Service": "الخدمة",
  "Service catalog and accounting classifications": "كتالوج الخدمات والتصنيفات المحاسبية",
  "Service code": "كود الخدمة",
  "Service name": "اسم الخدمة",
  "Service Type": "نوع الخدمة",
  "Session": "الحصة",
  "Session cancelled successfully": "الحصة اتلغت بنجاح",
  "Session checklist": "قائمة مراجعة الحصة",
  "Session created successfully": "الحصة اتعملت بنجاح",
  "Session expired. Please log in again.": "الجلسة انتهت. سجّل دخول تاني.",
  "Session Matrix": "جدول الحصة",
  "Session Meeting Link": "لينك اجتماع الحصة",
  "Session state": "حالة الحصة",
  "Session Timeline": "سجل الحصة",
  "Session Title": "عنوان الحصة",
  "Session Type": "نوع الحصة",
  "Sessions": "الحصص",
  "Sessions Scheduled": "الحصص المجدولة",
  "Set up the first language package": "إعداد أول باقة لغة",
  "Short Answer": "إجابة قصيرة",
  "Short exam description...": "وصف مختصر للامتحان...",
  "Show all": "عرض الكل",
  "Show everything": "عرض كل حاجة",
  "Show Login/Logout": "عرض تسجيل الدخول والخروج",
  "Show Metadata": "عرض البيانات الإضافية",
  "Showing": "عرض",
  "Showing first": "عرض أول",
  "Showing page": "عرض صفحة",
  "shown": "ظاهر",
  "Shown to students": "ظاهر للطلاب",
  "Skipped": "متخطّي",
  "Skipped sessions": "الحصص المتخطّية",
  "Slot": "الميعاد",
  "Slot Date": "تاريخ الميعاد",
  "Slot deleted": "الميعاد اتحذف",
  "Slot Filters": "فلاتر المواعيد",
  "Slot metadata": "بيانات الميعاد",
  "Slot selected": "الميعاد اتحدد",
  "slots": "مواعيد",
  "Sort By": "ترتيب حسب",
  "Sort by action": "ترتيب حسب الإجراء",
  "Sort by employee": "ترتيب حسب الموظف",
  "Sort by log id": "ترتيب حسب رقم السجل",
  "Sort by severity": "ترتيب حسب الخطورة",
  "Sort by status": "ترتيب حسب الحالة",
  "Source": "المصدر",
  "Source File": "ملف المصدر",
  "Speaking": "محادثة",
  "Speaking & Writing": "محادثة وكتابة",
  "Speaking/Writing": "محادثة / كتابة",
  "Stage": "المرحلة",
  "Start Date": "تاريخ البداية",
  "Start Month": "شهر البداية",
  "Start Refund": "بدء الاسترداد",
  "Start refund request": "بدء طلب استرداد",
  "Start request": "بدء الطلب",
  "Start Time": "وقت البداية",
  "State": "الحالة",
  "Status": "الحالة",
  "Status Legend": "دليل الحالات",
  "Step 1 of 2": "الخطوة 1 من 2",
  "Still studying": "لسه بيدرس",
  "Stopped groups": "المجموعات المتوقفة",
  "Street and city": "الشارع والمدينة",
  "Student": "الطالب",
  "Student answer": "إجابة الطالب",
  "Student Attendance": "حضور الطالب",
  "Student audio answer": "الإجابة الصوتية للطالب",
  "Student call rows": "سجلات الاتصال بالطلاب",
  "Student Chats": "شات الطلاب",
  "Student comments": "تعليقات الطالب",
  "Student delivery filter": "فلتر طريقة حضور الطالب",
  "Student Financial History": "سجل حساب الطالب",
  "Student follow-up": "متابعة الطالب",
  "Student history": "سجل الطالب",
  "Student Invoices": "فواتير الطلاب",
  "Student invoices for this branch will appear here.": "فواتير طلاب الفرع ده هتظهر هنا.",
  "Student Management": "إدارة الطلاب",
  "Student Name": "اسم الطالب",
  "Student name, code, group...": "اسم الطالب، الكود، المجموعة...",
  "Student name, code, phone...": "اسم الطالب، الكود، التليفون...",
  "Student note": "ملاحظة الطالب",
  "Student notification marked": "إبلاغ الطالب اتسجل",
  "Student or Submission": "الطالب أو التسجيل",
  "Student profile exists": "ملف الطالب موجود",
  "Student profile tabs": "تبويبات ملف الطالب",
  "Student Registrations": "تسجيلات الطلاب",
  "Student selection": "اختيار الطالب",
  "Student Status": "حالة الطالب",
  "Student updated": "بيانات الطالب اتحدّثت",
  "Student will be pending until approval flow marks Ready.": "الطالب هيفضل معلّق لحد ما مسار الموافقة يخليه جاهز.",
  "Student workflow": "مسار الطالب",
  "Student, course, month, note...": "الطالب، الكورس، الشهر، الملاحظة...",
  "Student's Reason": "سبب الطالب",
  "Students": "الطلاب",
  "students marked": "طلاب اتسجلوا",
  "Students waiting": "طلاب في الانتظار",
  "Subject": "الموضوع",
  "Subject Snapshot": "بيانات الموضوع",
  "Submissions": "التسجيلات",
  "Submit for approval": "إرسال للموافقة",
  "Submit Request": "إرسال الطلب",
  "Submit Work": "إرسال النتيجة",
  "Submitted": "اتبعت",
  "Submitted AI imports will appear here with live status.": "عمليات الاستيراد اللي اتبعتت هتظهر هنا بحالتها المباشرة.",
  "Submitted for review": "اتبعت للمراجعة",
  "Suggested": "مقترح",
  "Suggested Groups": "مجموعات مقترحة",
  "Suggested Level": "مستوى مقترح",
  "Suggested New Groups": "مجموعات جديدة مقترحة",
  "Suggestion Buckets": "فئات الاقتراحات",
  "suitable groups": "مجموعات مناسبة",
  "Summer Programs": "برامج الصيف",
  "Summer receipt not found.": "إيصال التدريب الصيفي مش موجود.",
  "Super Reception Controls": "أدوات مسؤول الريسبشن",
  "Supported: PDF, Audio (MP3, WAV), Video (MP4, AVI) · Select multiple files at once": "المتاح: PDF، صوت (MP3، WAV)، فيديو (MP4، AVI) · ممكن تختار أكتر من ملف مع بعض",
  "Syncing": "جاري المزامنة",
  "System Logs": "سجلات النظام",
  "System offer": "عرض من النظام",
  "System student": "طالب مسجل في النظام",
  "Target date": "التاريخ المستهدف",
  "Target group": "المجموعة المستهدفة",
  "Target Group Size": "حجم المجموعة المستهدف",
  "Target Student": "الطالب المستهدف",
  "Task": "المهمة",
  "Task accepted": "المهمة اتقبلت",
  "Task Checklist": "قائمة مراجعة المهمة",
  "Task details": "تفاصيل المهمة",
  "Task Management": "إدارة المهام",
  "Task Management Center": "مركز إدارة المهام",
  "Task marked done": "المهمة اتسجلت مكتملة",
  "Task moved to in progress": "المهمة بدأت تتنفذ",
  "Task payload is invalid": "بيانات المهمة مش صحيحة",
  "Task Title": "عنوان المهمة",
  "Task title, group code, note...": "عنوان المهمة، كود المجموعة، الملاحظة...",
  "Task title...": "عنوان المهمة...",
  "Task Type": "نوع المهمة",
  "tasks": "مهام",
  "Teaching Team": "فريق التدريب",
  "Team Activity": "نشاط الفريق",
  "Team Members": "أعضاء الفريق",
  "Team-wide": "كل الفريق",
  "This month": "الشهر ده",
  "This Week": "الأسبوع ده",
  "Ticket": "التذكرة",
  "Time": "الوقت",
  "Time Limit (min)": "الوقت المحدد (دقيقة)",
  "Time Limit": "الوقت المحدد",
  "Timestamp": "تاريخ ووقت التسجيل",
  "Title": "العنوان",
  "Title *": "العنوان *",
  "To": "لحد",
  "To date": "لحد تاريخ",
  "Today": "النهارده",
  "Today payments": "مدفوعات النهارده",
  "Today's Expenses": "مصروفات النهارده",
  "Today's Groups": "مجموعات النهارده",
  "Today's Income": "إيرادات النهارده",
  "Today's Invoices": "فواتير النهارده",
  "Today's Sessions": "حصص النهارده",
  "Top Expense Categories": "أعلى تصنيفات المصروفات",
  "Top Paying Students": "أعلى الطلاب دفعًا",
  "Total": "الإجمالي",
  "Total Cash Collected": "إجمالي النقدي المتحصّل",
  "Total Customer Payments": "إجمالي مدفوعات العملاء",
  "Total Exams": "إجمالي الامتحانات",
  "Total Expenses": "إجمالي المصروفات",
  "Total Forms": "إجمالي النماذج",
  "Total Groups": "إجمالي المجموعات",
  "Total hours": "إجمالي الساعات",
  "Total Income": "إجمالي الإيرادات",
  "Total Interests": "إجمالي الاهتمامات",
  "Total Logs": "إجمالي السجلات",
  "Total paid": "إجمالي المدفوع",
  "Total price": "السعر الإجمالي",
  "Total programs": "إجمالي البرامج",
  "Total Questions": "إجمالي الأسئلة",
  "Total Queue": "إجمالي الطابور",
  "Total Records": "إجمالي السجلات",
  "Total Reports": "إجمالي التقارير",
  "Total Requests": "إجمالي الطلبات",
  "Total Revenue": "إجمالي الإيرادات",
  "Total Scheduled": "إجمالي المجدول",
  "Total Slots": "إجمالي المواعيد",
  "Total Students": "إجمالي الطلاب",
  "Total Submissions": "إجمالي التسجيلات",
  "Total Tasks": "إجمالي المهام",
  "Total Today": "إجمالي النهارده",
  "Trainer name": "اسم المدرب",
  "Training end date": "تاريخ نهاية التدريب",
  "Training Group": "مجموعة التدريب",
  "Training start date": "تاريخ بداية التدريب",
  "Training Type": "نوع التدريب",
  "Training type change reason": "سبب تغيير نوع التدريب",
  "Transactions": "المعاملات",
  "Transfer Branch": "تحويل الفرع",
  "Transfer Credit": "تحويل الرصيد",
  "Transfer FROM (current course)": "التحويل من (الكورس الحالي)",
  "Transfer group": "نقل المجموعة",
  "True/False": "صح / غلط",
  "Try a different name or delivery filter.": "جرّب اسم أو فلتر حضور تاني.",
  "Try another branch, place, or course filter.": "جرّب فلتر فرع أو مكان أو كورس تاني.",
  "Try another filter or reset the current view.": "جرّب فلتر تاني أو ارجع العرض للوضع الافتراضي.",
  "Try another status tab or clear filters.": "جرّب تبويب حالة تاني أو امسح الفلاتر.",
  "Try another status, branch, or course.": "جرّب حالة أو فرع أو كورس تاني.",
  "Try another tab or reset filters.": "جرّب تبويب تاني أو رجّع الفلاتر للوضع الافتراضي.",
  "Try changing filters or clearing the search.": "جرّب تغيّر الفلاتر أو تمسح البحث.",
  "Try changing filters or refreshing the list.": "جرّب تغيّر الفلاتر أو تحدّث القائمة.",
  "Try changing filters or refreshing the log feed.": "جرّب تغيّر الفلاتر أو تحدّث السجلات.",
  "Try changing filters or status.": "جرّب تغيّر الفلاتر أو الحالة.",
  "Try changing the search term.": "جرّب تغيّر كلمة البحث.",
  "Try resetting filters or searching by another group code.": "جرّب تمسح الفلاتر أو تبحث بكود مجموعة تاني.",
  "Type": "النوع",
  "Type a custom course": "اكتب كورس مخصص",
  "Type a message...": "اكتب رسالة...",
  "Type course name": "اكتب اسم الكورس",
  "Typed answer": "إجابة مكتوبة",
  "Unassigned": "مش متعيّن",
  "Unavailable": "مش متاح",
  "Undone Tasks": "المهام اللي ما خلصتش",
  "Unique Students": "عدد الطلاب بدون تكرار",
  "University": "الجامعة",
  "Unknown error": "خطأ غير معروف",
  "Unlimited - leave empty": "بلا حد - سيبه فاضي",
  "Unmarked": "مش متسجل",
  "Unread": "لسه ما اتقراش",
  "Unread Reports": "التقارير اللي لسه ما اتقرتش",
  "Upcoming": "جاي",
  "Upcoming groups": "المجموعات الجاية",
  "Update Attendance": "تحديث الحضور",
  "Update each student result, then save the row.": "حدّث نتيجة كل طالب، وبعدها احفظ الصف.",
  "Update queue status": "تحديث حالة الطابور",
  "Update the related student, group, invoice, or session page.": "حدّث صفحة الطالب أو المجموعة أو الفاتورة أو الحصة المرتبطة.",
  "Updated": "اتحدّث",
  "Upload Learning Materials": "رفع مواد التعلم",
  "Upload materials": "رفع مواد",
  "Uploaded": "اترفع",
  "Uploader": "اللي رفعه",
  "Urgent": "عاجل",
  "Urgent follow-up": "متابعة عاجلة",
  "Urgent tasks": "مهام عاجلة",
  "Use Add Student to attach ready students.": "استخدم إضافة طالب عشان تضيف الطلاب الجاهزين.",
  "Use Open Attendance before the class starts. Assign an instructor if the group is still unassigned.": "افتح الحضور قبل الحصة ما تبدأ. عيّن مدرب لو المجموعة لسه من غير مدرب.",
  "Use this report to hand over any blockers to the next shift.": "استخدم التقرير عشان تسلّم أي مشاكل معطلة للشيفت اللي بعدك.",
  "Value": "القيمة",
  "Verified At": "تاريخ التحقق",
  "Verified By": "تحقق منه",
  "Verify": "تحقق",
  "Video": "فيديو",
  "View": "عرض",
  "View all": "عرض الكل",
  "View all registered students": "عرض كل الطلاب المسجلين",
  "View Attendance Matrix": "عرض جدول الحضور",
  "View Exam": "عرض الامتحان",
  "View invoice": "عرض الفاتورة",
  "View material": "عرض المادة",
  "View Receipt Image": "عرض صورة الإيصال",
  "View students": "عرض الطلاب",
  "View supporting document": "عرض المستند الداعم",
  "Visibility": "الظهور",
  "visible": "ظاهر",
  "Visible and hidden": "ظاهر ومخفي",
  "Visible to students": "ظاهر للطلاب",
  "Visible to the team only; not printed on the certificate.": "ظاهر للفريق بس؛ مش بيتطبع على الشهادة.",
  "Vodafone Cash": "فودافون كاش",
  "Void": "إلغاء السجل",
  "Void payment": "إلغاء الدفعة",
  "Void reason": "سبب إلغاء السجل",
  "Void Requested": "مطلوب إلغاء السجل",
  "Voided": "ملغي",
  "Voided / Cancelled": "ملغي / متوقف",
  "Voided payments remain in history and are excluded from balances.": "الدفعات الملغية بتفضل في السجل ومش بتتحسب في الأرصدة.",
  "Waiting": "انتظار",
  "Waiting Insights": "تحليلات الانتظار",
  "Waiting List": "قائمة الانتظار",
  "Waiting Planning": "تخطيط الانتظار",
  "Waiting Requests": "طلبات الانتظار",
  "Waiting selection": "اختيار الانتظار",
  "Waiting Students": "طلاب الانتظار",
  "Waiting to begin": "مستني البداية",
  "Waive Remaining Balance": "إعفاء من المبلغ الباقي",
  "Waived — no cash collected": "معفى — مفيش تحصيل نقدي",
  "Waiver Amount": "مبلغ الإعفاء",
  "Waiver issuance": "إصدار الإعفاء",
  "Waiver receipts": "إيصالات الإعفاء",
  "Wallet payment": "دفع بالمحفظة",
  "Warning": "تحذير",
  "Warning Days": "أيام التحذير",
  "Warning Min Fill": "الحد الأدنى للإشغال عند التحذير",
  "Weekdays": "أيام الأسبوع",
  "WhatsApp": "واتساب",
  "Weekly Demand": "الطلب الأسبوعي",
  "Why is the price being changed?": "إيه سبب تغيير السعر؟",
  "Why this student is waiting, preferred intake, constraints, ...": "سبب انتظار الطالب، الدفعة المناسبة، أي ظروف خاصة، ...",
  "With Student": "مع الطالب",
  "Work Summary *": "ملخص الشغل *",
  "Working": "جاري التنفيذ",
  "Write a note about attendance, reason, or payment...": "اكتب ملاحظة عن الحضور أو السبب أو الدفع...",
  "Write exactly how the task should be completed...": "اكتب بالظبط المهمة المفروض تتعمل إزاي...",
  "Write the question...": "اكتب السؤال...",
  "Write the reason...": "اكتب السبب...",
  "Write why this payment is rejected...": "اكتب سبب رفض الدفعة...",
  "Writing": "كتابة",
  "Written Answer": "إجابة مكتوبة",
  "Year": "السنة",
  "Yes": "أيوه",
  "You are cancelling": "إنت بتلغي",
  "You have an unsaved cancellation reason. Leave this page?": "سبب الإلغاء لسه ما اتحفظش. تسيب الصفحة؟",
  "You have an unsaved invoice cancellation reason. Leave this page?": "سبب إلغاء الفاتورة لسه ما اتحفظش. تسيب الصفحة؟",
  "You have an unsaved meeting link. Leave this page?": "لينك الاجتماع لسه ما اتحفظش. تسيب الصفحة؟",
  "You have an unsaved price change request. Leave this page?": "طلب تغيير السعر لسه ما اتحفظش. تسيب الصفحة؟",
  "Your branch": "فرعك",
  "Your browser does not support the audio element.": "المتصفح مش بيدعم تشغيل الصوت.",
  "Zoom Link": "لينك زووم",
  "Zoom, attendance, installment": "زووم، الحضور، القسط",
  "A course invoice already exists. A new free course invoice is blocked.": "فيه فاتورة كورس بالفعل. مش مسموح تعمل فاتورة كورس مجانية جديدة.",
  "A group cannot start without an assigned instructor. Unassigned groups can be saved as Planned.": "المجموعة ما ينفعش تبدأ من غير مدرب. ممكن تحفظ المجموعة من غير مدرب كحالة مخطط.",
  "Accounting records the payout separately after the money has been returned.": "الحسابات بتسجل الصرف بشكل منفصل بعد ما الفلوس ترجع.",
  "AI Pending": "مستني الذكاء الاصطناعي",
  "AI grading is still running. Scores will update automatically when grading finishes.": "التصحيح بالذكاء الاصطناعي لسه شغّال. الدرجات هتتحدّث تلقائيًا لما يخلص.",
  "Action, employee, subject, ID...": "الإجراء، الموظف، الموضوع، الرقم...",
  "Add Comment": "إضافة تعليق",
  "Add Consultation Slot": "إضافة ميعاد استشارة",
  "Add Course + Invoice": "إضافة كورس + فاتورة",
  "Add one or more tasks and send them to super reception.": "ضيف مهمة أو أكتر وابعتهم لمسؤول الريسبشن.",
  "Add students to group": "إضافة طلاب للمجموعة",
  "Add tasks to your queue. They become active immediately.": "ضيف المهام لطابورك. بتبقى نشطة فورًا.",
  "Add to combined PDF": "إضافة لملف PDF المجمّع",
  "Additional Package Levels": "مستويات الباقة الإضافية",
  "After this course receipt: Course Payments": "بعد إيصال الكورس ده: مدفوعات الكورس",
  "All Daily Reports": "كل التقارير اليومية",
  "All reports have been read.": "كل التقارير اتقرت.",
  "Amount Paid Now": "المبلغ المدفوع دلوقتي",
  "Amount matches the approved refund.": "المبلغ مطابق للاسترداد المعتمد.",
  "Anonymous": "بدون اسم",
  "Approve & Add to Group": "موافقة وإضافة للمجموعة",
  "Approve & Forward": "موافقة وإرسال",
  "Approve Join Request": "موافقة على طلب الانضمام",
  "Approve Payment": "موافقة على الدفعة",
  "Approved cancellation": "إلغاء معتمد",
  "Ask super reception or the general manager to link the original invoices for this request before accounting records it as paid.": "اطلب من مسؤول الريسبشن أو المدير العام ربط الفواتير الأصلية بالطلب قبل ما الحسابات تسجله كمدفوع.",
  "Awaiting super review": "مستني مراجعة مسؤول الريسبشن",
  "Balanced": "متوازن",
  "Because you are super reception, submitting this will mark the task as done immediately.": "عشان إنت مسؤول الريسبشن، إرسال النتيجة هيسجل المهمة مكتملة فورًا.",
  "Branch locked": "الفرع ثابت",
  "Branch needs review": "الفرع محتاج مراجعة",
  "Categories used": "التصنيفات المستخدمة",
  "Categorize the file first, then upload PDFs, audio, video, or links.": "صنّف الملف الأول، وبعدها ارفع PDF أو صوت أو فيديو أو لينكات.",
  "Check that every amount is a whole number within the receipt balance.": "اتأكد إن كل مبلغ رقم صحيح وفي حدود رصيد الإيصال.",
  "Choose": "اختار",
  "Choose a group": "اختار مجموعة",
  "Choose a language and level using the filters above, then click Load Materials to view existing content.": "اختار اللغة والمستوى من الفلاتر اللي فوق، وبعدها اضغط تحميل المواد عشان تشوف المحتوى الحالي.",
  "Choose source file": "اختار ملف المصدر",
  "Choose the amount to take from each receipt below. The total must equal": "اختار المبلغ من كل إيصال تحت. الإجمالي لازم يساوي",
  "Clear visible": "مسح المحدد الظاهر",
  "Collapse sidebar": "طي القائمة الجانبية",
  "Comments are linked to": "التعليقات مرتبطة بـ",
  "Compact attendance overview for": "ملخص حضور مختصر لـ",
  "Complete": "إتمام",
  "Complete the related work, then mark the task done.": "كمّل الشغل المرتبط، وبعدها سجّل المهمة مكتملة.",
  "Configure the report parameters below. The report will include all income sources (student invoices + additional income) and expenses for the selected period.": "حدد إعدادات التقرير تحت. التقرير هيشمل كل مصادر الإيراد (فواتير الطلاب + الإيرادات الإضافية) والمصروفات للفترة المحددة.",
  "Confirm Add to Group": "تأكيد الإضافة للمجموعة",
  "Confirm Finished": "تأكيد الإتمام",
  "Confirm the student has finished this course. Its waiting request will be closed. Other courses keep their status. Move this course to Waiting to reopen it.": "أكد إن الطالب خلّص الكورس ده. طلب الانتظار بتاعه هيتقفل. باقي الكورسات هتفضل بحالتها. انقل الكورس للانتظار عشان تفتحه تاني.",
  "Continue to Invoice": "كمّل للفاتورة",
  "Course balance unavailable. Confirm the course agreement before collecting a course payment.": "رصيد الكورس مش متاح. اتأكد من اتفاق الكورس قبل تحصيل أي دفعة.",
  "Course fully paid. Additional services are still available.": "الكورس مدفوع بالكامل. الخدمات الإضافية لسه متاحة.",
  "Course payment amount": "مبلغ دفعة الكورس",
  "Course payment amount (EGP)": "مبلغ دفعة الكورس (ج.م)",
  "Courses": "الكورسات",
  "Create": "إنشاء",
  "Create New Program": "إنشاء برنامج جديد",
  "Create Task": "إنشاء مهمة",
  "Create folder": "إنشاء مجلد",
  "Create speaking and writing prompts.": "إنشاء أسئلة محادثة وكتابة.",
  "Create your personal task list and send it to super reception for approval.": "اعمل قائمة مهامك وابعتها لمسؤول الريسبشن للموافقة.",
  "Create your personal task list. Super reception tasks are approved immediately.": "اعمل قائمة مهامك. مهام مسؤول الريسبشن بتتعتمد فورًا.",
  "Created from": "اتعمل من",
  "Created to": "اتعمل لحد",
  "Creating folder": "جاري إنشاء المجلد",
  "Current progress": "التقدم الحالي",
  "Default Meeting Link": "لينك الاجتماع الافتراضي",
  "Default for the group; each session can override it.": "الافتراضي للمجموعة؛ ممكن تحدد لينك مختلف لكل حصة.",
  "Delete comment": "حذف التعليق",
  "Detailed": "تفصيلي",
  "Detect comprehension passages and linked questions.": "تحديد قطع القراءة والأسئلة المرتبطة.",
  "Download PDF": "تنزيل PDF",
  "Download PDF Report": "تنزيل تقرير PDF",
  "Download image": "تنزيل الصورة",
  "Duplicate contact": "بيانات تواصل مكررة",
  "Duration is calculated from start/end time. Sessions are calculated from course hours.": "المدة بتتحسب من وقت البداية والنهاية. الحصص بتتحسب من ساعات الكورس.",
  "Edit Consultation Slot": "تعديل ميعاد الاستشارة",
  "Editing Program": "تعديل البرنامج",
  "Email Not Provided": "الإيميل مش متسجل",
  "Enter amount, e.g. 1205": "اكتب المبلغ، مثلًا 1205",
  "Enter the actual service amount. Service revenue does not change the course balance.": "اكتب مبلغ الخدمة الفعلي. إيراد الخدمة مش بيغيّر رصيد الكورس.",
  "Enter the recipient details manually; the certificate still gets an official number and permanent record.": "اكتب بيانات صاحب الشهادة يدويًا؛ الشهادة هتاخد رقم رسمي وسجل دائم.",
  "Enter the recipient full name": "اكتب الاسم الكامل لصاحب الشهادة",
  "Enter valid dates as dd/mm/yyyy. From must not be after To.": "اكتب تواريخ صحيحة بصيغة يوم/شهر/سنة. تاريخ البداية ما ينفعش يكون بعد النهاية.",
  "Enter valid whole amounts.": "اكتب مبالغ صحيحة من غير كسور.",
  "Error Loading Students": "حصل خطأ في تحميل الطلاب",
  "Every action with its actor and date in Cairo time, newest first. Missing historical details are shown as “Not recorded”.": "كل إجراء ظاهر بالموظف والتاريخ بتوقيت القاهرة، الأحدث الأول. التفاصيل القديمة الناقصة بتظهر «مش متسجل».",
  "Example: A1.1 - Unit 1": "مثال: A1.1 - Unit 1",
  "Example: Group notes - Week 1": "مثال: ملاحظات المجموعة - الأسبوع الأول",
  "Example: Verified the student's original receipt for this course refund.": "مثال: اتراجعت فاتورة الطالب الأصلية لاسترداد الكورس ده.",
  "Expand sidebar": "فتح القائمة الجانبية",
  "Expense details": "تفاصيل المصروف",
  "Explain why these original receipts belong to this refund. Use at least 10 characters.": "وضّح ليه الإيصالات الأصلية دي تخص الاسترداد ده. اكتب 10 حروف على الأقل.",
  "Explain why this request is rejected...": "اكتب سبب رفض الطلب...",
  "Extract MCQs and answer choices.": "استخراج أسئلة الاختيار من متعدد والإجابات.",
  "Failed": "ما تمّش",
  "Failed to load": "التحميل ما تمّش",
  "Fetching real materials from reception records.": "جاري تحميل المواد من سجلات الريسبشن.",
  "Finish the task already in progress before starting another one.": "خلّص المهمة اللي شغّالة الأول قبل ما تبدأ واحدة تانية.",
  "First": "الأول",
  "Flag unsupported PDF images for manual review.": "تحديد صور PDF غير المدعومة للمراجعة اليدوية.",
  "For a different course use Add Course + Invoice in the student profile.": "لكورس مختلف، استخدم إضافة كورس + فاتورة من ملف الطالب.",
  "For missing correct answers, mark the intended option in the edit form.": "لو الإجابة الصحيحة ناقصة، حدد الاختيار الصحيح في نموذج التعديل.",
  "Found": "اتلاقى",
  "Free-of-charge and remaining-balance waivers are issued automatically by the employee who submits the receipt.": "إعفاءات الرسوم والمبلغ الباقي بيصدرها تلقائيًا الموظف اللي بيبعت الإيصال.",
  "General": "عام",
  "General comment": "تعليق عام",
  "Generate Report": "إنشاء تقرير",
  "Group name not recorded": "اسم المجموعة مش متسجل",
  "Guest": "ضيف",
  "Hide": "إخفاء",
  "How students attend": "طريقة حضور الطلاب",
  "If set, updates the total course fee and recalculates remaining balance.": "لو اتحدد، هيحدّث إجمالي رسوم الكورس ويحسب المبلغ الباقي تاني.",
  "Import with AI": "استيراد بالذكاء الاصطناعي",
  "Income": "الإيراد",
  "Income by category": "الإيرادات حسب التصنيف",
  "Income categories": "تصنيفات الإيراد",
  "Income details": "تفاصيل الإيراد",
  "Installment schedule exceeds the remaining balance by": "جدول الأقساط بيزيد عن المبلغ الباقي بـ",
  "Invoice availability could not be loaded. Reopen this request before linking receipts.": "ما قدرناش نحمّل الفواتير المتاحة. افتح الطلب تاني قبل ربط الإيصالات.",
  "Invoice data could not be loaded.": "ما قدرناش نحمّل بيانات الفاتورة.",
  "Invoice details are temporarily unavailable.": "تفاصيل الفاتورة مش متاحة مؤقتًا.",
  "Invoice must have linked student, total price, and no pending edit.": "الفاتورة لازم تكون مربوطة بطالب، فيها سعر إجمالي، ومن غير تعديل مستني الموافقة.",
  "Last": "الأخير",
  "Lead selected a sales consultation slot and needs reception follow-up.": "العميل اختار ميعاد استشارة مبيعات ومحتاج متابعة من الريسبشن.",
  "Legacy — needs classification": "قديم — محتاج تصنيف",
  "Link the original payment receipts so accounting can complete this refund.": "اربط إيصالات الدفع الأصلية عشان الحسابات تقدر تكمّل الاسترداد.",
  "Log details": "تفاصيل السجل",
  "Managed by": "بيديره",
  "Manual Review": "مراجعة يدوية",
  "Manual records stay in the certificate register but are never shown in a student account.": "السجلات اليدوية بتفضل في سجل الشهادات ومش بتظهر في حساب أي طالب.",
  "Mark All Present": "تسجيل الكل حاضر",
  "Mark Did Not Complete": "تسجيل كغير مكتمل",
  "Mark Done": "تسجيل كمكتمل",
  "Mark Paid": "تسجيل كمدفوع",
  "Mark Pending": "تسجيل كمعلّق",
  "Mark Reviewed": "تسجيل كمراجَع",
  "Mark read": "تسجيل كمقروء",
  "Matching rules": "قواعد المطابقة",
  "Missing details": "تفاصيل ناقصة",
  "Missing required data": "بيانات مطلوبة ناقصة",
  "Move to Waiting": "نقل للانتظار",
  "Multiple registrations exist. Link this group to the correct registration in the customer account before collecting.": "فيه أكتر من تسجيل. اربط المجموعة بالتسجيل الصحيح في حساب العميل قبل التحصيل.",
  "Name, email, code, phone...": "الاسم، الإيميل، الكود، التليفون...",
  "New course": "كورس جديد",
  "Newest": "الأحدث",
  "No Data Found": "مفيش بيانات",
  "No Installment Required": "مش محتاج قسط",
  "No Student": "مفيش طالب",
  "No activity history yet.": "مفيش سجل نشاط لسه.",
  "No additional courses available": "مفيش كورسات إضافية متاحة",
  "No additional courses available in the catalog for this student.": "مفيش كورسات إضافية متاحة للطالب ده في الكتالوج.",
  "No additional income entries yet": "مفيش إيرادات إضافية لسه",
  "No assignment rows returned.": "مفيش سجلات تكليف اتبعتت.",
  "No attendance data found for this group.": "مفيش بيانات حضور للمجموعة دي.",
  "No attendance matrix data found for this group.": "مفيش بيانات جدول حضور للمجموعة دي.",
  "No available groups for this student and course.": "مفيش مجموعات متاحة للطالب والكورس دول.",
  "No branch": "مفيش فرع",
  "No branches available": "مفيش فروع متاحة",
  "No certificates found": "مفيش شهادات بالاختيارات دي",
  "No code": "مفيش كود",
  "No comments yet": "مفيش تعليقات لسه",
  "No compatible group available.": "مفيش مجموعة مناسبة متاحة.",
  "No consult requests found": "مفيش طلبات استشارة بالاختيارات دي",
  "No contact recorded": "مفيش بيانات تواصل مسجلة",
  "No coupons yet": "مفيش كوبونات لسه",
  "No course": "مفيش كورس",
  "No courses available": "مفيش كورسات متاحة",
  "No current courses available": "مفيش كورسات حالية متاحة",
  "No daily reports match your current filters.": "مفيش تقارير يومية بالاختيارات دي.",
  "No data": "مفيش بيانات",
  "No data available": "مفيش بيانات متاحة",
  "No data for this period": "مفيش بيانات للفترة دي",
  "No demand rows for current filters.": "مفيش طلب بالاختيارات دي.",
  "No description provided.": "مفيش وصف متسجل.",
  "No eligible original invoices with a refundable balance were found for this student and course. Check the original receipts before continuing.": "مفيش فواتير أصلية مؤهلة فيها رصيد قابل للاسترداد للطالب والكورس دول. راجع الإيصالات الأصلية قبل ما تكمّل.",
  "No employee folders found": "مفيش مجلدات موظفين",
  "No entries in this view": "مفيش سجلات في العرض ده",
  "No entries match these filters.": "مفيش سجلات بالاختيارات دي.",
  "No exam details available": "مفيش تفاصيل امتحان متاحة",
  "No exams match your filters": "مفيش امتحانات بالاختيارات دي",
  "No expense entries yet": "مفيش مصروفات لسه",
  "No expenses": "مفيش مصروفات",
  "No finance data available.": "مفيش بيانات حسابات متاحة.",
  "No finance summary is available for this branch.": "مفيش ملخص حسابات متاح للفرع ده.",
  "Finance summary could not be loaded. Other available data is shown below.": "تعذّر تحميل ملخص الحسابات. البيانات المتاحة ظاهرة بالأسفل.",
  "Invoices could not be loaded.": "تعذّر تحميل الفواتير.",
  "Retry finance summary": "إعادة تحميل ملخص الحسابات",
  "Retry invoices": "إعادة تحميل الفواتير",
  "Retry additional income": "إعادة تحميل الإيرادات الإضافية",
  "Retry expenses": "إعادة تحميل المصروفات",
  "Finance refresh failed. Previously loaded data is still displayed.": "تعذّر تحديث بيانات الحسابات. البيانات المحمّلة سابقًا ما زالت معروضة.",
  "No folder": "مفيش مجلد",
  "No folder selected": "مفيش مجلد محدد",
  "No follow-up rows available for this task.": "مفيش سجلات متابعة متاحة للمهمة دي.",
  "No groups assigned yet.": "مفيش مجموعات متعيّنة لسه.",
  "No groups for this branch today.": "مفيش مجموعات للفرع ده النهارده.",
  "No groups found": "مفيش مجموعات بالاختيارات دي",
  "No groups scheduled for this day.": "مفيش مجموعات مجدولة لليوم ده.",
  "No groups today": "مفيش مجموعات النهارده",
  "No import jobs yet": "مفيش عمليات استيراد لسه",
  "No inactive students.": "مفيش طلاب غير نشطين.",
  "No income": "مفيش إيرادات",
  "No installment due within 30 days.": "مفيش قسط مستحق خلال 30 يوم.",
  "No installments scheduled yet for this invoice.": "مفيش أقساط مجدولة للفاتورة دي لسه.",
  "No instructions provided.": "مفيش تعليمات متسجلة.",
  "No interests found": "مفيش اهتمامات بالكورسات بالاختيارات دي",
  "No invoices found": "مفيش فواتير بالاختيارات دي",
  "No invoices today": "مفيش فواتير النهارده",
  "No language filter": "مفيش فلتر لغة",
  "No linked student. The lead must register before this invoice can be processed.": "مفيش طالب مرتبط. العميل لازم يسجل قبل تنفيذ الفاتورة.",
  "No logs found": "مفيش سجلات بالاختيارات دي",
  "No longer needed": "مش مطلوب خلاص",
  "No matching coupons": "مفيش كوبونات مطابقة",
  "No matching forms": "مفيش نماذج مطابقة",
  "No matching groups": "مفيش مجموعات مطابقة",
  "No matching options": "مفيش اختيارات مطابقة",
  "No matching payments": "مفيش مدفوعات مطابقة",
  "No matching programs": "مفيش برامج مطابقة",
  "No matching registrations": "مفيش تسجيلات مطابقة",
  "No matching students": "مفيش طلاب مطابقين",
  "No materials found": "مفيش مواد بالاختيارات دي",
  "No materials loaded": "مفيش مواد اتحملت",
  "No mentor": "مفيش موجّه",
  "No messages yet": "مفيش رسايل لسه",
  "No open tasks": "مفيش مهام مفتوحة",
  "No original invoices linked.": "مفيش فواتير أصلية مرتبطة.",
  "No paying students in this period.": "مفيش طلاب دافعين في الفترة دي.",
  "No payment required": "مش محتاج دفع",
  "No payment submitted": "مفيش دفعة اتبعتت",
  "No payments found": "مفيش مدفوعات بالاختيارات دي",
  "No payments recorded for this student.": "مفيش مدفوعات مسجلة للطالب ده.",
  "No pending reviews at the moment": "مفيش مراجعات معلّقة دلوقتي",
  "No pending self task approvals.": "مفيش موافقات مهام ذاتية معلّقة.",
  "No placement exams yet": "مفيش امتحانات تحديد مستوى لسه",
  "No planned capacity": "مفيش سعة مخططة",
  "No planned groups for this bucket.": "مفيش مجموعات مخططة للفئة دي.",
  "No previous receipts": "مفيش إيصالات سابقة",
  "No quarter groups found": "مفيش مجموعات للدورة دي",
  "No questions in this section yet.": "مفيش أسئلة في القسم ده لسه.",
  "No real records match the current filters. Clear filters or choose another branch/course.": "مفيش سجلات بالاختيارات الحالية. امسح الفلاتر أو اختار فرع أو كورس تاني.",
  "No receipt image": "مفيش صورة إيصال",
  "No reception employees are available for this branch.": "مفيش موظفين ريسبشن متاحين للفرع ده.",
  "No record yet": "مفيش سجل لسه",
  "No recorded actions.": "مفيش إجراءات مسجلة.",
  "No registered students here": "مفيش طلاب مسجلين هنا",
  "No requests found": "مفيش طلبات بالاختيارات دي",
  "No response data": "مفيش بيانات إجابة",
  "No response provided": "مفيش إجابة متسجلة",
  "No scoped student found.": "مفيش طالب في النطاق المتاح ليك.",
  "No sections yet": "مفيش أقسام لسه",
  "No sections.": "مفيش أقسام.",
  "No session data found.": "مفيش بيانات للحصة.",
  "No sessions created yet": "مفيش حصص اتعملت لسه",
  "No sessions found": "مفيش حصص بالاختيارات دي",
  "No sessions found for this month. Try another month or branch filter.": "مفيش حصص للشهر ده. جرّب شهر أو فلتر فرع تاني.",
  "No sessions scheduled": "مفيش حصص مجدولة",
  "No sessions today": "مفيش حصص النهارده",
  "No slots found": "مفيش مواعيد بالاختيارات دي",
  "No students attached": "مفيش طلاب مضافين",
  "No students found": "مفيش طلاب بالاختيارات دي",
  "No students in waiting for current filters.": "مفيش طلاب في الانتظار بالاختيارات دي.",
  "No students match the current filters.": "مفيش طلاب بالاختيارات دي.",
  "No suggestion rows for current filters.": "مفيش اقتراحات بالاختيارات دي.",
  "No summer forms yet": "مفيش نماذج تدريب صيفي لسه",
  "No summer groups yet": "مفيش مجموعات تدريب صيفي لسه",
  "No summer payments yet": "مفيش مدفوعات تدريب صيفي لسه",
  "No summer programs yet": "مفيش برامج تدريب صيفي لسه",
  "No summer training registrations yet": "مفيش تسجيلات تدريب صيفي لسه",
  "No task plan submitted yet.": "مفيش خطة مهام اتبعتت لسه.",
  "No tasks found": "مفيش مهام بالاختيارات دي",
  "No tasks match the current filters.": "مفيش مهام بالاختيارات دي.",
  "No transfers recorded.": "مفيش تحويلات مسجلة.",
  "Only cancellation of a previously paid amount requires manager approval.": "إلغاء مبلغ اتدفع قبل كده بس هو اللي محتاج موافقة المدير.",
  "Only showing logs that require immediate approval. Other logs will be visible once all pending danger actions are resolved.": "الظاهر دلوقتي السجلات اللي محتاجة موافقة فورية بس. باقي السجلات هتظهر بعد حل كل إجراءات الخطر المعلّقة.",
  "Override placement test requirement for this student? They will be able to access their dashboard without taking the test.": "تلغي شرط اختبار تحديد المستوى للطالب ده؟ هيقدر يدخل لوحة المتابعة من غير الاختبار.",
  "Required for any balance not covered by existing installments. A due installment will be created for that balance.": "مطلوب لأي مبلغ باقي مش متغطّي بالأقساط الحالية. هيتعمل قسط مستحق للمبلغ ده.",
  "Review the answers, confirm the final level, then assign the student to the correct group.": "راجع الإجابات وأكد المستوى النهائي، وبعدها عيّن الطالب للمجموعة الصحيحة.",
  "Set a target date. The student will appear in the Waiting tab and demand planning insights. Any current group for this course will be removed automatically.": "حدد تاريخ مستهدف. الطالب هيظهر في تبويب الانتظار وتحليلات التخطيط. أي مجموعة حالية للكورس ده هتتشال تلقائيًا.",
  "The group ID provided is not valid.": "رقم المجموعة مش صحيح.",
  "The level advances automatically only when the student joins the next sequential group.": "المستوى بيتقدم تلقائيًا بس لما الطالب ينضم للمجموعة التالية بالترتيب.",
  "The session ID provided is not valid.": "رقم الحصة مش صحيح.",
  "The training end date cannot be before the start date.": "تاريخ نهاية التدريب ما ينفعش يكون قبل البداية.",
  "These questions were modified after this attempt was submitted": "الأسئلة دي اتعدّلت بعد إرسال المحاولة",
  "This action may notify the students and instructor.": "الإجراء ده ممكن يبلّغ الطلاب والمدرب.",
  "This action should be reviewed carefully.": "راجع الإجراء ده كويس.",
  "This creates a pending request; it still follows the existing eligibility and approval workflow.": "ده بيعمل طلب معلّق، ولسه بيخضع لنفس شروط الأهلية والموافقة.",
  "This entry will be voided immediately. A warning will be recorded and super reception will be notified.": "السجل هيتلغي فورًا. هيتسجل تحذير ويتبلّغ مسؤول الريسبشن.",
  "This material does not have a valid URL.": "المادة دي مفيهاش لينك صحيح.",
  "This request will be sent to super reception for approval. The entry stays active until approved.": "الطلب هيتبعت لمسؤول الريسبشن للموافقة. السجل هيفضل نشط لحد الموافقة.",
  "This saved material opens on an external website.": "المادة المحفوظة دي بتفتح موقع خارجي.",
  "This student is no longer in the selected group. Refresh the profile.": "الطالب مش في المجموعة المحددة دلوقتي. حدّث الملف.",
  "This supporting-document URL is not safe to open.": "لينك المستند الداعم مش آمن للفتح.",
  "This will be the first invoice for this student.": "دي هتكون أول فاتورة للطالب.",
  "This will remove the selected comment permanently for everyone.": "ده هيحذف التعليق المحدد نهائيًا عند الكل.",
  "To save, allocate exactly the approved amount and enter an approval reason.": "عشان تحفظ، خصص نفس المبلغ المعتمد بالظبط واكتب سبب الموافقة.",
  "Total cannot be less than amount already paid.": "الإجمالي ما ينفعش يكون أقل من المبلغ المدفوع بالفعل.",
  "Total price is missing. This invoice cannot be approved until pricing is completed elsewhere.": "السعر الإجمالي ناقص. الفاتورة مش ممكن تتعتمد لحد ما التسعير يكتمل.",
  "Upload .txt or .pdf. Plain text is recommended; PDF images are ignored.": "ارفع .txt أو .pdf. النص العادي أفضل؛ صور PDF مش بتتقرأ.",
  "When importing exams ensure the prompt includes correct_option_label for each MCQ.": "عند استيراد الامتحان، اتأكد إن التعليمات فيها correct_option_label لكل سؤال اختيار من متعدد.",
  "When off, only signed-in eligible students can open it.": "لو مقفول، الطلاب المؤهلين المسجلين دخولهم بس يقدروا يفتحوه.",
  "Not recorded": "مش متسجل",
  "N/A": "غير متاح",
  "PDF": "PDF",
  "EN": "EN",
  "GER": "GER",
  "Arabian Academy": "أريبيان أكاديمي",
  "Arabian Academy Finance System": "نظام حسابات أريبيان أكاديمي",
  "e.g. 20": "مثلًا 20",
  "e.g. 36": "مثلًا 36",
  "e.g. partner or learner code": "مثلًا كود الشريك أو المتعلم",
  "e.g. UI/UX Design Diploma": "مثلًا دبلومة تصميم UI/UX",
  "e.g., 30": "مثلًا 30",
  "e.g., 5": "مثلًا 5",
  "e.g., student moved, requested change, capacity, etc.": "مثلًا انتقال الطالب، طلب تغيير، السعة، وغيرها",
  "e.g., Week 4 - Introduction to Course": "مثلًا الأسبوع الرابع - مقدمة الكورس",
  "14 digits": "14 رقم",
  "/14 digits": "/14 رقم",
  "/ 10 minimum characters": "/ 10 حروف على الأقل",
  "/20 minimum characters": "/20 حرف على الأقل",
  "1. Enter the refund amount": "1. اكتب مبلغ الاسترداد",
  "2. Approval reason": "2. سبب الموافقة",
  "10 / page": "10 / صفحة",
  "20 / page": "20 / صفحة",
  "50 / page": "50 / صفحة",
  "(Optional)": "(اختياري)",
  "(optional)": "(اختياري)",
  "(required)": "(مطلوب)",
  "(empty)": "(فاضي)",
  "(Check policy)": "(راجع السياسة)",
  "% complete": "% مكتمل",
  "% of total": "% من الإجمالي",
  "# Sessions": "عدد الحصص",
  "+ Option": "+ اختيار",
  "← Back": "← رجوع",
  "&larr; Back": "← رجوع",
  "- Due": "- مستحق",
  "- Group #": "- مجموعة رقم",
  "· By:": "· بواسطة:",
  "· Course Remaining": "· باقي الكورس",
  "· Course:": "· الكورس:",
  "· Created": "· اتعمل",
  "· Enter amount": "· اكتب المبلغ",
  "· Interested Course:": "· الكورس المطلوب:",
  "· Internal Student ID:": "· رقم الطالب الداخلي:",
  "· Package:": "· الباقة:",
  "· Planned end:": "· النهاية المخططة:",
  "· Preferred Branch:": "· الفرع المفضل:",
  "· Remaining:": "· الباقي:",
  "· Session": "· الحصة",
  "· Starts": "· البداية",
  "· Updated": "· اتحدّث",
  "of": "من",
  "at": "في",
  "by": "بواسطة",
  "on": "في",
  "as invalid.": "كغير صالح.",
  "documented identity exceptions": "استثناءات الهوية الموثقة",
  "invoices recorded today.": "فواتير اتسجلت النهارده.",
  "is available": "متاح",
  "is the number of groups to create.": "هو عدد المجموعات المطلوب إنشاؤها.",
  "minutes ·": "دقيقة ·",
  "questions ·": "سؤال ·",
  "records from current filters.": "سجلات بالاختيارات الحالية.",
  "reports.": "تقارير.",
  "saved successfully.": "اتحفظ بنجاح.",
  "scheduled on": "مجدول في",
  "sessions for": "حصص لـ",
  "shows real student demand.": "بيوضح طلب الطلاب الفعلي.",
  "shows seats already planned.": "بيوضح الأماكن المخططة بالفعل.",
  "students": "طلاب",
  "tasks from current filters.": "مهام بالاختيارات الحالية.",
  "tasks of": "مهام من",
  "total consult requests ·": "إجمالي طلبات الاستشارة ·",
  "visible slots.": "مواعيد ظاهرة.",
  ". Legacy comments appear across courses.": ". التعليقات القديمة بتظهر في كل الكورسات.",
  ". The change applies immediately and super reception will be notified.": ". التغيير بيتطبق فورًا وبيتبلّغ مسؤول الريسبشن.",
  "). A reason and confirmation are required; existing approval rules apply.": "). مطلوب سبب وتأكيد؛ قواعد الموافقة الحالية بتتطبق.",
  "). Existing approval rules apply.": "). قواعد الموافقة الحالية بتتطبق.",
  ": Attendance mode mismatch: student attendance and group delivery require review.": ": طريقة الحضور مش متطابقة: حضور الطالب وطريقة المجموعة محتاجين مراجعة.",
  ": Finished": ": خلص",
  "; open tasks page for the full list.": "؛ افتح صفحة المهام للقائمة الكاملة.",
  "EGP / Refunded:": "ج.م / المسترد:",
  "EGP ·": "ج.م ·",
  "EGP — set a due date in the invoice screen.": "ج.م — حدد تاريخ استحقاق من شاشة الفاتورة.",
  "EGP)": "ج.م)",
  "EGP. Current balance is the remaining amount across course accounts.": "ج.م. الرصيد الحالي هو إجمالي المبلغ الباقي في حسابات الكورسات.",
  "EGP. Linking invoices does not send another payment.": "ج.م. ربط الفواتير مش بيبعت دفعة تانية.",
  "EGP. Open the student invoice to set a due date.": "ج.م. افتح فاتورة الطالب عشان تحدد تاريخ استحقاق.",
  "EGP. Review the schedule before collecting.": "ج.م. راجع الجدول قبل التحصيل.",
  "remains active while the manager reviews this request. If approved, it will stay in history as cancelled and be excluded from active totals.": "هيفضل نشط أثناء مراجعة المدير للطلب. لو اتوافق عليه، هيفضل في السجل كملغي ومش هيتحسب في الإجماليات النشطة.",
  "Could not open WhatsApp. Please try again.": "ما قدرناش نفتح واتساب. جرّب تاني.",
  "Could not open WhatsApp connection. Please try again.": "ما قدرناش نفتح صفحة اتصال واتساب. جرّب تاني.",
  "WhatsApp Inbox": "صندوق واتساب",
  "WhatsApp Connection": "اتصال واتساب",
  "Opening…": "جاري الفتح…",
  "Connect my number": "ربط رقمي",
  "Manage WhatsApp connection": "إدارة اتصال واتساب",
  "Back to inbox": "رجوع لصندوق الوارد",
  "Your account": "حسابك",
  "Generated from the event template": "مولّدة من قالب الفعالية",
  "Could not load event certificates.": "ما قدرناش نحمّل شهادات الفعالية.",
  "Enter the phone number first.": "اكتب رقم التليفون الأول.",
  "Choose a certificate image first.": "اختار صورة الشهادة الأول.",
  "Could not upload the certificate.": "ما قدرناش نرفع الشهادة.",
  "The previous certificate for this number was replaced.": "الشهادة القديمة للرقم ده اتبدّلت.",
  "The certificate was uploaded and linked to the number.": "الشهادة اترفعت واتربطت بالرقم.",
  "Choose an Excel file first.": "اختار ملف Excel الأول.",
  "Could not import the Excel file.": "ما قدرناش نستورد ملف Excel.",
  "Creating certificates...": "جارٍ إنشاء الشهادات...",
  "Create certificates": "إنشاء الشهادات",
  "Uploading and saving...": "جارٍ الرفع والحفظ...",
  "Upload and link certificate": "رفع وربط الشهادة",
  "Could not load the list.": "ما قدرناش نحمّل القائمة.",
  "Switch to English": "التبديل للإنجليزي",
  "Egyptian Arabic": "عربي مصري",
  "Booking deposit": "مقدم حجز",
  "Administration workspace": "مساحة الإدارة",
  "New registration": "تسجيل جديد",
  "Back to Reception": "رجوع للريسبشن",
  "Loading": "جاري التحميل",
  "Loading summer training workspace...": "جاري تحميل قسم التدريب الصيفي...",
  "Could not load summer training workspace": "ما قدرناش نحمّل التدريب الصيفي",
  "Refresh the page after checking the backend is available.": "حدّث الصفحة بعد ما تتأكد إن السيرفر شغّال.",
  "Search by registration number, student, or program...": "ابحث برقم التسجيل أو الطالب أو البرنامج...",
  "Summer Training": "التدريب الصيفي",
  "Summer Term 2026": "الفصل الصيفي 2026",
  "Summer Training Dashboard": "لوحة التدريب الصيفي",
  "Track summer training registrations, groups, attendance, and payments.": "متابعة تسجيلات التدريب الصيفي والمجموعات والحضور والمدفوعات.",
  "New registrations": "تسجيلات جديدة",
  "Registrations appear here after students submit a published form.": "التسجيلات هتظهر هنا بعد ما الطلاب يبعتوا نموذج منشور.",
  "Publish New Form": "نشر نموذج جديد",
  "Record Payment": "تسجيل دفعة",
  "Program Management": "إدارة البرامج",
  "Create and manage summer training programs only.": "إنشاء وإدارة برامج التدريب الصيفي بس.",
  "Available immediately in summer training forms.": "متاح فورًا في نماذج التدريب الصيفي.",
  "Slug": "الرابط المختصر",
  "Choose university": "اختار الجامعة",
  "Choose faculty": "اختار الكلية",
  "Create Program": "إنشاء البرنامج",
  "Update Program": "تحديث البرنامج",
  "Cancel editing": "إلغاء التعديل",
  "No academy course links are used here.": "مفيش ربط بكورسات الأكاديمية هنا.",
  "Create a summer program before publishing a registration form.": "اعمل برنامج تدريب صيفي قبل نشر نموذج التسجيل.",
  "Change or clear the search term.": "غيّر كلمة البحث أو امسح البحث.",
  "Fees": "المصروفات",
  "Manage summer term registration forms and student information.": "إدارة نماذج التسجيل وبيانات الطلاب الخاصة بالفصل الصيفي.",
  "Published / Active": "منشور / فعال",
  "Total Registrations": "إجمالي التسجيلات",
  "Public link": "الرابط العام",
  "Set up registration form": "إعداد نموذج التسجيل",
  "Choose which information students must submit.": "حدد البيانات اللي الطالب لازم يبعتها.",
  "Create Form": "إنشاء نموذج",
  "Open form builder": "فتح بناء النموذج",
  "Form builder": "بناء النموذج",
  "Form information": "بيانات النموذج",
  "Saved forms": "النماذج المحفوظة",
  "No program selected": "مفيش برنامج محدد",
  "Form fields": "حقول النموذج",
  "Add field": "إضافة حقل",
  "Delete field": "حذف الحقل",
  "Save Form": "حفظ النموذج",
  "Update Form": "تحديث النموذج",
  "Public links open this form's fields.": "اللينكات العامة بتعرض حقول النموذج.",
  "Create and publish a form to open public registration links.": "اعمل نموذج وانشره عشان تفتح لينكات التسجيل العامة.",
  "Publish": "نشر",
  "Registration Management": "إدارة التسجيلات",
  "Review and update trainee registration statuses.": "مراجعة وتحديث حالات تسجيل المتدربين.",
  "Sort: newest first": "ترتيب حسب: الأحدث",
  "Students appear here after submitting a published summer training form.": "الطلاب هتظهر هنا بعد إرسال نموذج تدريب صيفي منشور.",
  "Registration number": "رقم التسجيل",
  "Trainee name": "اسم المتدرب",
  "Training program": "البرنامج التدريبي",
  "Submission date": "تاريخ التقديم",
  "Password setup link sent.": "لينك إعداد كلمة السر اتبعت.",
  "Password setup link was not sent. Check email settings.": "لينك إعداد كلمة السر ما اتبعتش. راجع إعدادات الإيميل.",
  "Organize and track trainee groups in active programs.": "تنظيم ومتابعة مجموعات المتدربين داخل البرامج الفعالة.",
  "Choose program": "اختار البرنامج",
  "Create Group": "إنشاء المجموعة",
  "Choose registration": "اختار التسجيل",
  "Assign": "تسكين",
  "Create groups after verifying registrations.": "اعمل المجموعات بعد التحقق من التسجيلات.",
  "No schedule": "مفيش مواعيد",
  "Daily Attendance": "الحضور اليومي",
  "Create sessions and record summer training group attendance.": "إنشاء جلسات وتسجيل حضور مجموعات التدريب الصيفي.",
  "Save Session": "حفظ الجلسة",
  "Choose session": "اختار الحصة",
  "active registrations available": "تسجيلات نشطة متاحة",
  "Create a group session, then mark students present, absent, or late.": "اعمل حصة للمجموعة، وبعدها سجّل الطلاب حاضر أو غايب أو متأخر.",
  "Payment Management": "إدارة المدفوعات",
  "Record payments and issue summer training receipts only.": "تسجيل مدفوعات وإصدار إيصالات للتدريب الصيفي بس.",
  "Record a payment for a summer training registration.": "تسجيل معاملة دفع مرتبطة بتسجيل تدريب صيفي.",
  "Search by name, email, or student ID...": "ابحث بالاسم أو الإيميل أو رقم الطالب...",
  "Payment Method": "طريقة الدفع",
  "Confirm Payment": "تأكيد الدفع",
  "Payments here issue a summer training receipt and do not change academy invoices.": "أي دفعة هنا بتصدر إيصال تدريب صيفي ومش بتغيّر فواتير الأكاديمية.",
  "Payment void reason": "سبب إلغاء الدفعة",
  "Card": "بطاقة",
  "Bank Transfer": "تحويل بنكي",
  "Type program name": "اكتب اسم البرنامج",
  "program-slug": "رابط-البرنامج",
  "Type form title": "اكتب عنوان النموذج",
  "form-slug": "رابط-النموذج",
  "fields": "حقول",
  "Form title is required.": "عنوان النموذج مطلوب.",
  "Add university and faculty fields": "إضافة حقول الجامعة والكلية",
  "Coupon Management": "إدارة الكوبونات",
  "Create discount coupons linked to a university and faculty.": "إنشاء كوبونات خصم مرتبطة بجامعة وكلية.",
  "Fixed amount": "مبلغ ثابت",
  "Percentage": "نسبة مئوية",
  "Create Coupon": "إنشاء الكوبون",
  "Create a coupon after adding university and faculty options to programs.": "اعمل كوبون بعد إضافة اختيارات الجامعة والكلية في البرامج.",
  "Used": "المستخدم",
  "Summer training coupon created.": "كوبون التدريب الصيفي اتعمل.",
  "Add at least one valid field.": "ضيف حقل صحيح واحد على الأقل.",
  "Field codes must be unique": "أكواد الحقول لازم تكون مختلفة",
  "Add at least one field.": "ضيف حقل واحد على الأقل.",
  "Every field needs an internal code.": "كل حقل لازم يكون له كود داخلي.",
  "Every field needs a visible label.": "كل حقل لازم يكون له عنوان ظاهر.",
  "A summer training form already uses this slug.": "فيه نموذج تدريب صيفي بنفس الرابط المختصر.",
  "Could not save the summer training form.": "ما قدرناش نحفظ نموذج التدريب الصيفي.",
  "Summer training program created.": "برنامج التدريب الصيفي اتعمل.",
  "Summer training program updated.": "برنامج التدريب الصيفي اتحدّث.",
  "Summer training form saved.": "نموذج التدريب الصيفي اتحفظ.",
  "Summer training form updated.": "نموذج التدريب الصيفي اتحدّث.",
  "Summer training form published.": "نموذج التدريب الصيفي اتنشر.",
  "Registration status updated.": "حالة التسجيل اتحدّثت.",
  "Summer training group created.": "مجموعة التدريب الصيفي اتعملت.",
  "Could not create the summer training group.": "ما قدرناش نعمل مجموعة التدريب الصيفي.",
  "Student assigned to the summer training group.": "الطالب اتسكّن في مجموعة التدريب الصيفي.",
  "Could not assign the student to the summer training group.": "ما قدرناش نسكّن الطالب في مجموعة التدريب الصيفي.",
  "Summer training session created.": "حصة التدريب الصيفي اتعملت.",
  "Could not create the summer training session.": "ما قدرناش نعمل حصة التدريب الصيفي.",
  "Attendance updated.": "الحضور اتحدّث.",
  "Payment recorded. Receipt": "الدفعة اتسجلت. إيصال",
  "Could not record the summer training payment.": "ما قدرناش نسجل دفعة التدريب الصيفي.",
  "Payment voided and its receipt marked voided.": "الدفعة اتلغت والإيصال المرتبط اتسجل ملغي.",
  "Program and group name are required.": "اختار البرنامج واكتب اسم المجموعة.",
  "Group and registration are required.": "اختار المجموعة والتسجيل.",
  "Group and date are required.": "اختار المجموعة والتاريخ.",
  "Registration and amount are required.": "اختار التسجيل واكتب المبلغ.",
  "Published": "منشور",
  "New": "جديد",
  "Verified": "تم التحقق",
  "Assigned": "تم التسكين",
  "Archived": "مؤرشف",
  "Draft": "مسودة",
  "Arabic": "العربية",
  "Attendance Availability": "طريقة الحضور المتاحة",
  "Offline Branches": "الفروع الحضورية",
  "· Last updated": "· آخر تحديث",
  "· Invalid:": "· غير صالحة:",
  "· Updated:": "· محدّثة:",
  "Refresh list": "تحديث القائمة",
  "View certificate": "عرض الشهادة",
  "Reception team": "فريق الاستقبال",
  ". To connect another employee's number, use that employee's account.": ". لربط رقم موظف تاني، استخدم حساب الموظف ده.",
  "PNG, JPG or WEBP — up to 10 MB": "PNG أو JPG أو WEBP — حتى 10 MB",
  "Latest uploaded certificates": "آخر الشهادات المرفوعة",
  "Any number connected here is automatically registered under": "أي رقم تربطه هنا بيتسجل تلقائيًا باسم",
  "Send Email": "إرسال بالبريد الإلكتروني",
  "Send WhatsApp": "إرسال WhatsApp",
  "Upload the first certificate using the form beside this list.": "ارفع أول شهادة من النموذج اللي جنب القائمة.",
  "Upload XLSX: name in column A (NAME), phone in column B. A certificate is created for each valid row; full phone numbers are not retained.": "ارفع ملف XLSX: الاسم في العمود A (NAME) والتليفون في العمود B. بتتعمل شهادة لكل صف صحيح؛ رقم التليفون الكامل مش بيتحفظ.",
  "Phone numbers are always masked.": "أرقام التليفون بتظهر مخفية دايمًا.",
  "You can see your conversations and your reporting employees' conversations based on the manager recorded in Arabian.": "بتشوف محادثاتك ومحادثات الموظفين التابعين ليك حسب المدير المباشر المسجل في أريبيان.",
  "Phone/name conflicts:": "تعارض رقم/اسم:",
  "Could not open WhatsApp": "ما قدرناش نفتح واتساب",
  "Generate certificates from Excel": "توليد الشهادات من Excel",
  "Loading receipt...": "جاري تحميل الإيصال...",
  "New:": "جديدة:",
  "Upload new certificate": "رفع شهادة جديدة",
  "Phone number registered for the event": "رقم الهاتف المسجل بالفعالية",
  "Programming Event Certificates": "شهادات فعالية البرمجة",
  "Valid rows:": "صفوف صالحة:",
  "Identical duplicate rows:": "صفوف مكررة متطابقة:",
  "Certificate image": "صورة الشهادة",
  "Using the same number again replaces the previous image and invalidates its old preview links.": "استخدام نفس الرقم تاني بيبدّل الصورة السابقة تلقائيًا وبيوقف لينكات المعاينة القديمة.",
  "Uploading again for the same number replaces the previous certificate.": "إعادة الرفع لنفس الرقم تستبدل الشهادة السابقة.",
  "Before Brand template": "قالب Before Brand",
  "No uploaded certificates yet": "مفيش شهادات مرفوعة لسه",
  "Skipped:": "متجاوزة:",
  "This workspace is separate from official student certificates. Full phone numbers are not stored; public search remains exact and protected.": "المساحة دي منفصلة عن شهادات الطلاب الرسمية. رقم التليفون الكامل مش بيتحفظ؛ البحث العام بيفضل دقيق ومحمي.",
  "Excel file": "ملف Excel",
  "WhatsApp — {0}": "واتساب — {0}",
  "Opening WhatsApp…": "جاري فتح واتساب…",
  "Loading certificates...": "جاري تحميل الشهادات...",
  "Could not load certificates.": "ما قدرناش نحمّل الشهادات.",
  "Could not load groups.": "ما قدرناش نحمّل المجموعات.",
  "Could not load student details.": "ما قدرناش نحمّل تفاصيل الطالب.",
  "Could not load student history.": "ما قدرناش نحمّل سجل الطالب.",
  "Failed to load consultation slots.": "ما قدرناش نحمّل مواعيد الاستشارات.",
  "Failed to load course interests.": "ما قدرناش نحمّل الاهتمام بالكورسات.",
  "Failed to load daily summary": "ما قدرناش نحمّل ملخص اليوم",
  "Failed to load group join requests.": "ما قدرناش نحمّل طلبات الانضمام للمجموعات.",
  "Failed to load group students.": "ما قدرناش نحمّل طلاب المجموعة.",
  "Failed to load placement payments.": "ما قدرناش نحمّل مدفوعات تحديد المستوى.",
  "Failed to load refund requests.": "ما قدرناش نحمّل طلبات الاسترداد.",
  "Failed to load sales consultation queue.": "ما قدرناش نحمّل طابور استشارات المبيعات.",
  "Failed to load summary": "ما قدرناش نحمّل الملخص",
  "Failed to load summer training workspace": "ما قدرناش نحمّل مساحة التدريب الصيفي",
  "Failed to load task.": "ما قدرناش نحمّل المهمة.",
  "Loading attempt details...": "جاري تحميل تفاصيل المحاولة...",
  "Loading attempt...": "جاري تحميل المحاولة...",
  "Loading attempts...": "جاري تحميل المحاولات...",
  "Loading branch finance...": "جاري تحميل حسابات الفرع...",
  "Loading branch transfers": "جاري تحميل تحويلات الفروع",
  "Loading checklist...": "جاري تحميل قائمة المراجعة...",
  "Loading comments": "جاري تحميل التعليقات",
  "Loading comments...": "جاري تحميل التعليقات...",
  "Loading course catalog…": "جاري تحميل كتالوج الكورسات…",
  "Loading daily reports...": "جاري تحميل التقارير اليومية...",
  "Loading daily summary...": "جاري تحميل ملخص اليوم...",
  "Loading employee folders...": "جاري تحميل مجلدات الموظفين...",
  "Loading entries...": "جاري تحميل السجلات...",
  "Loading exam...": "جاري تحميل الامتحان...",
  "Loading exams...": "جاري تحميل الامتحانات...",
  "Loading finance dashboard...": "جاري تحميل لوحة الحسابات...",
  "Loading group...": "جاري تحميل المجموعة...",
  "Loading groups...": "جاري تحميل المجموعات...",
  "Loading insights...": "جاري تحميل التحليلات...",
  "Loading interest...": "جاري تحميل الاهتمام بالكورس...",
  "Loading invoice data...": "جاري تحميل بيانات الفاتورة...",
  "Loading invoice details...": "جاري تحميل تفاصيل الفاتورة...",
  "Loading log details...": "جاري تحميل تفاصيل السجل...",
  "Loading materials": "جاري تحميل المواد",
  "Loading options...": "جاري تحميل الاختيارات...",
  "Loading payment details...": "جاري تحميل تفاصيل الدفعة...",
  "Loading placement exams...": "جاري تحميل امتحانات تحديد المستوى...",
  "Loading pro finance dashboard...": "جاري تحميل لوحة الحسابات التفصيلية...",
  "Loading queue item...": "جاري تحميل سجل الطابور...",
  "Loading receipt details...": "جاري تحميل تفاصيل الإيصال...",
  "Loading records...": "جاري تحميل السجلات...",
  "Loading refund details...": "جاري تحميل تفاصيل الاسترداد...",
  "Loading registered students": "جاري تحميل الطلاب المسجلين",
  "Loading report...": "جاري تحميل التقرير...",
  "Loading request details...": "جاري تحميل تفاصيل الطلب...",
  "Loading reviews...": "جاري تحميل المراجعات...",
  "Loading sales invoices...": "جاري تحميل فواتير المبيعات...",
  "Loading self task approvals...": "جاري تحميل موافقات المهام الذاتية...",
  "Loading service catalog…": "جاري تحميل كتالوج الخدمات…",
  "Loading sessions...": "جاري تحميل الحصص...",
  "Loading slot...": "جاري تحميل الميعاد...",
  "Loading student details": "جاري تحميل تفاصيل الطالب",
  "Loading student details...": "جاري تحميل تفاصيل الطالب...",
  "Loading student finance...": "جاري تحميل حساب الطالب...",
  "Loading student history": "جاري تحميل سجل الطالب",
  "Loading student...": "جاري تحميل الطالب...",
  "Loading students": "جاري تحميل الطلاب",
  "Loading students...": "جاري تحميل الطلاب...",
  "Loading suggestion...": "جاري تحميل الاقتراح...",
  "Loading suitable groups": "جاري تحميل المجموعات المناسبة",
  "Loading summer receipt...": "جاري تحميل إيصال التدريب الصيفي...",
  "Loading target groups...": "جاري تحميل المجموعات المستهدفة...",
  "Loading task...": "جاري تحميل المهمة...",
  "Loading tasks...": "جاري تحميل المهام...",
  "Loading today's groups": "جاري تحميل مجموعات النهارده",
  "Loading today's groups.": "جاري تحميل مجموعات النهارده.",
  "Loading waiting details...": "جاري تحميل تفاصيل الانتظار...",
  "Loading waiting insights...": "جاري تحميل تحليلات الانتظار...",
  "Loading your submitted plans...": "جاري تحميل خططك المرسلة...",
  "Loading your tasks...": "جاري تحميل مهامك...",
  "Failed to acknowledge notification": "ما قدرناش نكمّل تأكيد استلام التنبيه",
  "Failed to approve invoice": "ما قدرناش نكمّل الموافقة على الفاتورة",
  "Failed to delete material": "ما قدرناش نكمّل حذف المادة",
  "Failed to export waiting students": "ما قدرناش نكمّل تصدير طلاب الانتظار",
  "Failed to fetch attempts": "ما قدرناش نكمّل تحميل المحاولات",
  "Failed to fetch materials": "ما قدرناش نكمّل تحميل المواد",
  "Failed to fetch placement exams": "ما قدرناش نكمّل تحميل امتحانات تحديد المستوى",
  "Failed to fetch task detail": "ما قدرناش نكمّل تحميل تفاصيل المهمة",
  "Failed to fetch tasks": "ما قدرناش نكمّل تحميل المهام",
  "Failed to load branch transfers": "ما قدرناش نحمّل تحويلات الفروع",
  "Failed to load comments": "ما قدرناش نحمّل التعليقات",
  "Failed to load contacts": "ما قدرناش نحمّل بيانات التواصل",
  "Failed to load exam": "ما قدرناش نحمّل الامتحان",
  "Failed to load exams": "ما قدرناش نحمّل الامتحانات",
  "Failed to load expenses": "ما قدرناش نحمّل المصروفات",
  "Failed to load group attendance": "ما قدرناش نحمّل حضور المجموعة",
  "Failed to load groups": "ما قدرناش نحمّل المجموعات",
  "Failed to load incomes": "ما قدرناش نحمّل الإيرادات",
  "Failed to load installments": "ما قدرناش نحمّل الأقساط",
  "Failed to load invoice data.": "ما قدرناش نحمّل بيانات الفاتورة.",
  "Failed to load matrix": "ما قدرناش نحمّل جدول الحضور",
  "Failed to load quarter alert settings": "ما قدرناش نحمّل إعدادات تنبيهات الدورة",
  "Failed to load sales invoice counts": "ما قدرناش نحمّل أعداد فواتير المبيعات",
  "Failed to load self task approvals": "ما قدرناش نحمّل موافقات المهام الذاتية",
  "Failed to load session": "ما قدرناش نحمّل الحصة",
  "Failed to load target groups": "ما قدرناش نحمّل المجموعات المستهدفة",
  "Failed to load task": "ما قدرناش نحمّل المهمة",
  "Failed to load your self tasks": "ما قدرناش نحمّل مهامك الذاتية",
  "Failed to mark report as read": "ما قدرناش نكمّل تسجيل التقرير كمقروء",
  "Failed to reject invoice": "ما قدرناش نكمّل رفض الفاتورة",
  "Failed to resolve branch finance scope": "ما قدرناش نكمّل تحديد نطاق حسابات الفرع",
  "Failed to resolve finance scope": "ما قدرناش نكمّل تحديد نطاق الحسابات",
  "Failed to resolve pro finance scope": "ما قدرناش نكمّل تحديد نطاق الحسابات التفصيلية",
  "Failed to save score": "ما قدرناش نكمّل حفظ الدرجة",
  "Failed to search contacts": "ما قدرناش نكمّل البحث في بيانات التواصل",
  "Failed to submit comment": "ما قدرناش نكمّل إرسال التعليق",
  "Failed to toggle active state": "ما قدرناش نكمّل تغيير حالة التفعيل",
  "Failed to toggle review": "ما قدرناش نكمّل تغيير حالة المراجعة",
  "Failed to toggle visibility": "ما قدرناش نكمّل تغيير الظهور",
  "Failed to update daily session checklist": "ما قدرناش نكمّل تحديث قائمة مراجعة الحصة اليومية",
  "Failed to update follow-up row": "ما قدرناش نكمّل تحديث سجل المتابعة",
  "Failed to update quarter alert conditions": "ما قدرناش نكمّل تحديث شروط تنبيهات الدورة",
  "Failed to update state": "ما قدرناش نكمّل تحديث الحالة",
  "Failed to update task": "ما قدرناش نكمّل تحديث المهمة",
  "Failed to update visibility": "ما قدرناش نكمّل تحديث الظهور",
  "EGP.": "ج.م.",
  "Reset Filters": "إعادة ضبط الفلاتر",
  "Target Date": "التاريخ المستهدف",
  "groups": "المجموعات",
  "invoices": "الفواتير",
  "payments": "المدفوعات",
  "session": "الحصة",
  "sessions": "الحصص",
  "student": "الطالب",
  "to": "لحد",
  "total": "الإجمالي",
  "total requests": "إجمالي الطلبات",
  "total slots": "إجمالي المواعيد",
  "AI Import": "استيراد بالذكاء الاصطناعي",
  "Absent:": "غايب:",
  "Active:": "نشط:",
  "Add Option": "إضافة اختيار",
  "Add Section": "إضافة قسم",
  "Additional service": "خدمة إضافية",
  "All branches": "كل الفروع",
  "Amount:": "المبلغ:",
  "Answer:": "الإجابة:",
  "Answered:": "اتجاوب:",
  "Approval note": "ملاحظة الموافقة",
  "Approve invoice": "موافقة على الفاتورة",
  "Approved:": "تمت الموافقة:",
  "Assigned To": "متعيّنة لـ",
  "Audience:": "الفئة المستهدفة:",
  "Audit Exam:": "مراجعة الامتحان:",
  "Branch:": "الفرع:",
  "By:": "بواسطة:",
  "Cancellation rejected:": "الإلغاء اترفض:",
  "Capacity:": "السعة:",
  "Choose purpose": "اختار الغرض",
  "Comment:": "التعليق:",
  "Correct:": "صح:",
  "Cost center:": "مركز التكلفة:",
  "Course / Program": "الكورس / البرنامج",
  "Course Name": "اسم الكورس",
  "Course payment": "دفعة الكورس",
  "Course:": "الكورس:",
  "Created:": "اتعمل:",
  "Date:": "التاريخ:",
  "Edit Task": "تعديل المهمة",
  "Edit group": "تعديل المجموعة",
  "Enter amount in Egyptian Pounds.": "اكتب المبلغ بالجنيه المصري.",
  "Entry to request for void:": "السجل المطلوب إلغاؤه:",
  "Entry to void:": "السجل اللي هيتلغي:",
  "Error:": "خطأ:",
  "FREE OF CHARGE": "بدون رسوم",
  "From:": "من:",
  "Group Details": "تفاصيل المجموعة",
  "Group Status:": "حالة المجموعة:",
  "ID:": "الرقم:",
  "Issued By:": "أصدره:",
  "Level:": "المستوى:",
  "Manual Grading": "تصحيح يدوي",
  "Missing follow-up": "متابعة ناقصة",
  "Model Answer:": "الإجابة النموذجية:",
  "Move Student": "نقل طالب",
  "Needs Instructor": "محتاج مدرب",
  "Net Total:": "الإجمالي الصافي:",
  "No comments yet.": "مفيش تعليقات لسه.",
  "No sections yet.": "مفيش أقسام لسه.",
  "Note:": "الملاحظة:",
  "Open Attendance": "فتح الحضور",
  "Overdue installments:": "الأقساط المتأخرة:",
  "Paid:": "مدفوع:",
  "Passport Number": "رقم جواز السفر",
  "Pending:": "معلّق:",
  "Phone:": "التليفون:",
  "Placement Test": "اختبار تحديد المستوى",
  "Planned groups:": "المجموعات المخططة:",
  "Points": "نقطة",
  "Present:": "حاضر:",
  "Question Text": "نص السؤال",
  "Reading passage...": "قطعة القراءة...",
  "Reason:": "السبب:",
  "Receipt Image": "صورة الإيصال",
  "Receipt Image:": "صورة الإيصال:",
  "Receipt Preview": "معاينة الإيصال",
  "Reception": "الريسبشن",
  "Reception Note": "ملاحظة الريسبشن",
  "Registration Status:": "حالة التسجيل:",
  "Rejected:": "مرفوض:",
  "Rejection Reason": "سبب الرفض",
  "Remaining:": "الباقي:",
  "Renewal price": "سعر التجديد",
  "Room:": "القاعة:",
  "Saving...": "جاري الحفظ...",
  "Saving…": "جاري الحفظ…",
  "Score:": "الدرجة:",
  "Seats:": "الأماكن:",
  "Sections:": "الأقسام:",
  "Select Course": "اختار الكورس",
  "Selected": "محدد",
  "Sort by": "ترتيب حسب",
  "Status:": "الحالة:",
  "Student Status:": "حالة الطالب:",
  "Student's Reason:": "سبب الطالب:",
  "Student:": "الطالب:",
  "Submitted for Review": "اتبعت للمراجعة",
  "Submitted:": "اتبعت:",
  "Suggested:": "مقترح:",
  "Super Reception Controls:": "أدوات مسؤول الريسبشن:",
  "Target Group": "المجموعة المستهدفة",
  "This Month": "الشهر ده",
  "Ticket:": "التذكرة:",
  "Time Limit:": "الوقت المحدد:",
  "Total Expenses:": "إجمالي المصروفات:",
  "Total Paid": "إجمالي المدفوع",
  "Total Price": "السعر الإجمالي",
  "Total Questions:": "إجمالي الأسئلة:",
  "Total Revenue:": "إجمالي الإيرادات:",
  "Total income": "إجمالي الإيرادات",
  "Total:": "الإجمالي:",
  "Type:": "النوع:",
  "View Invoice": "عرض الفاتورة",
  "Visible": "ظاهر",
  "Void reason:": "سبب إلغاء السجل:",
  "Voided / Cancelled:": "ملغي / متوقف:",
  "Waiting:": "انتظار:",
  "WhatsApp connection": "اتصال واتساب",
  "Working...": "جاري التنفيذ...",
  "schedule needed": "محتاج جدولة",
  "All Statuses": "كل الحالات",
  "Branch Payment": "دفع في الفرع",
  "Choose Course": "اختار الكورس",
  "danger": "خطر",
  "Last 30 Days": "آخر 30 يوم",
  "Last 7 Days": "آخر 7 أيام",
  "status": "الحالة",
  "warning": "تحذير",
  "Failed to generate PDF. Please try again.": "ما قدرناش نعمل PDF. جرّب تاني.",
  "Failed to get CSRF token. Please refresh and try again.": "ما قدرناش نجهز رمز حماية الطلب. حدّث الصفحة وجرّب تاني.",
  "Failed to issue invoice. Please try again.": "ما قدرناش نصدر الفاتورة. جرّب تاني.",
  "Failed to load Arabic font": "ما قدرناش نحمّل الخط العربي",
  "Failed to load calendar": "ما قدرناش نحمّل التقويم",
  "No Answer": "مفيش إجابة",
  "No branch options were returned.": "مفيش اختيارات فرع اتبعتت.",
  "No course options were returned.": "مفيش اختيارات كورس اتبعتت.",
  "Image prompt": "سؤال على صورة",
  "Intro session": "حصة تعريفية",
  "Introduction Session": "حصة تعريفية",
  "Invalid group response": "بيانات المجموعة مش صحيحة",
  "Invalid import job id": "رقم مهمة الاستيراد مش صحيح",
  "Invalid import job status response": "بيانات حالة مهمة الاستيراد مش صحيحة",
  "Invalid interest response": "بيانات الاهتمام بالكورس مش صحيحة",
  "Invalid invoice ID": "رقم الفاتورة مش صحيح",
  "Invalid invoice receipt data.": "بيانات إيصال الفاتورة مش صحيحة.",
  "Invalid job status response": "بيانات حالة المهمة مش صحيحة",
  "Invalid queue response": "بيانات الطابور مش صحيحة",
  "Invalid reception workflow draft": "مسودة إجراء الريسبشن مش صحيحة",
  "Invalid report response": "بيانات التقرير مش صحيحة",
  "Invalid request response": "بيانات الطلب مش صحيحة",
  "Invalid slot response": "بيانات الميعاد مش صحيحة",
  "Invalid student response": "بيانات الطالب مش صحيحة",
  "Invalid task plan draft": "مسودة خطة المهام مش صحيحة",
  "Invalid task response": "بيانات المهمة مش صحيحة",
  "Invalid attempt id": "رقم المحاولة مش صحيح",
  "Invalid exam id": "رقم الامتحان مش صحيح",
  "Invalid Group ID": "رقم المجموعة مش صحيح",
  "Invalid group ID.": "رقم المجموعة مش صحيح.",
  "Invalid Session ID": "رقم الحصة مش صحيح",
  "Invalid student id": "رقم الطالب مش صحيح",
  "Attempt response does not match the requested id": "بيانات المحاولة مش مطابقة للرقم المطلوب",
  "Attendance group response did not match the requested group": "بيانات مجموعة الحضور مش مطابقة للمجموعة المطلوبة",
  "Attendance matrix response did not match the requested group": "بيانات جدول الحضور مش مطابقة للمجموعة المطلوبة",
  "Attendance session response did not match the requested session": "بيانات حضور الحصة مش مطابقة للحصة المطلوبة",
  "Exam response does not match the requested id": "بيانات الامتحان مش مطابقة للرقم المطلوب",
  "Exam response does not match the saved id": "بيانات الامتحان مش مطابقة للرقم المحفوظ",
  "Invoice bundle response did not match the requested student": "بيانات الفواتير مش مطابقة للطالب المطلوب",
  "Unsafe navigation session value: invalid material categorization": "بيانات التنقل مش آمنة: تصنيف المادة مش صحيح",
  "Good afternoon, Reception": "مساء الخير يا ريسبشن",
  "Good afternoon, Reception 👋": "مساء الخير يا ريسبشن 👋",
  "Good afternoon,": "مساء الخير،",
  "External": "خارجي",
  "Public": "عام",
  "Online / أونلاين": "أونلاين",
  "Offline / أوفلاين": "حضوري",
  "Service added": "الخدمة اتضافت",
  "Service saved": "الخدمة اتحفظت",
  "Service amount": "مبلغ الخدمة",
  "Registration branch": "فرع التسجيل",
  "Requested training type": "نوع التدريب المطلوب",
  "Current training type": "نوع التدريب الحالي"
};

// Known Arabic source UI normalized for the default English reception workspace.
export const pageEnglishTranslations: Record<string, string> = {
  "تعذر فتح واتساب. حاول مرة أخرى.": "Could not open WhatsApp. Please try again.",
  "تعذر فتح صفحة اتصال واتساب. حاول مرة أخرى.": "Could not open WhatsApp connection. Please try again.",
  "صندوق واتساب": "WhatsApp Inbox",
  "اتصال واتساب": "WhatsApp Connection",
  "جارٍ الفتح…": "Opening…",
  "ربط رقمي": "Connect my number",
  "إدارة اتصال واتساب": "Manage WhatsApp connection",
  "العودة لصندوق الوارد": "Back to inbox",
  "حسابك": "Your account",
  "مولّدة من قالب الفعالية": "Generated from the event template",
  "تعذر تحميل شهادات الفعالية.": "Could not load event certificates.",
  "أدخل رقم الهاتف أولًا.": "Enter the phone number first.",
  "اختر صورة الشهادة أولًا.": "Choose a certificate image first.",
  "تعذر رفع الشهادة.": "Could not upload the certificate.",
  "تم استبدال الشهادة السابقة لهذا الرقم.": "The previous certificate for this number was replaced.",
  "تم رفع الشهادة وربطها بالرقم.": "The certificate was uploaded and linked to the number.",
  "اختر ملف Excel أولًا.": "Choose an Excel file first.",
  "تعذر استيراد ملف Excel.": "Could not import the Excel file.",
  "اختر ملف Excel الذي يحتوي على الاسم ورقم الهاتف.": "Choose an Excel file with the name and phone number.",
  "تم تجهيز {0} شهادة من ملف Excel.": "{0} certificates were prepared from the Excel file.",
  "جارٍ إنشاء الشهادات...": "Creating certificates...",
  "إنشاء الشهادات": "Create certificates",
  "جارٍ الرفع والحفظ...": "Uploading and saving...",
  "رفع وربط الشهادة": "Upload and link certificate",
  "تعذر تحميل القائمة.": "Could not load the list.",
  "التبديل للإنجليزي": "Switch to English",
  "عربي مصري": "Egyptian Arabic",
  "مقدم حجز": "Booking deposit",
  "دفعة": "Payment",
  "لوحة التحكم": "Dashboard",
  "البرامج": "Programs",
  "النماذج": "Forms",
  "التسجيلات": "Registrations",
  "المجموعات": "Groups",
  "الحضور": "Attendance",
  "المدفوعات": "Payments",
  "الكوبونات": "Coupons",
  "مساحة الإدارة": "Administration workspace",
  "تسجيل جديد": "New registration",
  "العودة للاستقبال": "Back to Reception",
  "تحديث": "Refresh",
  "إغلاق": "Close",
  "جاري التحميل": "Loading",
  "جاري تحميل قسم التدريب الصيفي...": "Loading summer training workspace...",
  "تعذر تحميل قسم التدريب الصيفي": "Could not load summer training workspace",
  "حدّث الصفحة بعد التأكد أن الباك اند يعمل.": "Refresh the page after checking the backend is available.",
  "ابحث برقم التسجيل أو الطالب أو البرنامج...": "Search by registration number, student, or program...",
  "التدريب الصيفي": "Summer Training",
  "الفصل الصيفي 2026": "Summer Term 2026",
  "لوحة التدريب الصيفي": "Summer Training Dashboard",
  "متابعة التسجيلات والمجموعات والحضور والمدفوعات الخاصة بالتدريب الصيفي.": "Track summer training registrations, groups, attendance, and payments.",
  "تسجيلات جديدة": "New registrations",
  "طلاب نشطون": "Active students",
  "إجمالي البرامج": "Total programs",
  "مدفوعات اليوم": "Today payments",
  "أحدث التسجيلات": "Latest Registrations",
  "عرض الكل": "View all",
  "لا توجد تسجيلات تدريب صيفي بعد": "No summer training registrations yet",
  "التسجيلات ستظهر هنا فور إرسال الطلاب لنموذج منشور.": "Registrations appear here after students submit a published form.",
  "إجراءات سريعة": "Quick Actions",
  "إنشاء برنامج جديد": "Create New Program",
  "نشر نموذج جديد": "Publish New Form",
  "تسجيل دفعة": "Record Payment",
  "إدارة البرامج": "Program Management",
  "إنشاء وإدارة برامج التدريب الصيفي من summer_programs فقط.": "Create and manage summer training programs only.",
  "يصبح متاحًا فورًا داخل نماذج التدريب الصيفي.": "Available immediately in summer training forms.",
  "اسم البرنامج": "Program Name",
  "الرابط المختصر": "Slug",
  "الجامعة": "University",
  "الكلية": "Faculty",
  "اختر الجامعة": "Choose university",
  "اختر الكلية": "Choose faculty",
  "المصروفات (EGP)": "Fees (EGP)",
  "السعة": "Capacity",
  "الوصف": "Description",
  "إنشاء البرنامج": "Create Program",
  "تعديل البرنامج": "Edit program",
  "تحديث البرنامج": "Update Program",
  "إلغاء التعديل": "Cancel editing",
  "برامج التدريب الصيفي": "Summer Programs",
  "لا يوجد أي ربط مباشر بكورسات الأكاديمية هنا.": "No academy course links are used here.",
  "لا توجد برامج تدريب صيفي بعد": "No summer programs yet",
  "أنشئ برنامج تدريب صيفي قبل نشر نموذج التسجيل.": "Create a summer program before publishing a registration form.",
  "لا توجد برامج مطابقة": "No matching programs",
  "غيّر كلمة البحث أو امسح مربع البحث.": "Change or clear the search term.",
  "الفترة": "Period",
  "المصروفات": "Fees",
  "الحالة": "Status",
  "إدارة نماذج التسجيل وبيانات الطلاب الخاصة بالفصل الصيفي.": "Manage summer term registration forms and student information.",
  "إجمالي النماذج": "Total Forms",
  "منشور / فعال": "Published / Active",
  "إجمالي التسجيلات": "Total Registrations",
  "الرابط العام": "Public link",
  "إعداد نموذج التسجيل": "Set up registration form",
  "حدد بالضبط البيانات التي يجب أن يرسلها الطالب.": "Choose which information students must submit.",
  "عنوان النموذج": "Form Title",
  "إنشاء نموذج": "Create Form",
  "فتح بناء النموذج": "Open form builder",
  "بناء النموذج": "Form builder",
  "بيانات النموذج": "Form information",
  "النماذج المحفوظة": "Saved forms",
  "البرنامج": "Program",
  "بدون برنامج محدد": "No program selected",
  "حقول النموذج": "Form fields",
  "إضافة حقل": "Add field",
  "نوع الحقل": "Field Type",
  "عنوان الحقل": "Field label",
  "إجباري": "Required",
  "حذف الحقل": "Delete field",
  "الاختيارات مفصولة بفواصل": "Options separated by comma",
  "حفظ النموذج": "Save Form",
  "تحديث النموذج": "Update Form",
  "تعديل النموذج": "Edit form",
  "جاري الحفظ": "Saving",
  "النماذج المنشورة والمسودات": "Published and Draft Forms",
  "الروابط العامة تعرض الحقول الديناميكية من summer_form_fields.": "Public links open this form's fields.",
  "لا توجد نماذج تدريب صيفي بعد": "No summer forms yet",
  "أنشئ وانشر نموذجًا لفتح روابط التسجيل العامة.": "Create and publish a form to open public registration links.",
  "لا توجد نماذج مطابقة": "No matching forms",
  "الإجراءات": "Actions",
  "تعديل": "Edit",
  "نشر": "Publish",
  "إدارة التسجيلات": "Registration Management",
  "مراجعة وتحديث حالات تسجيل المتدربين.": "Review and update trainee registration statuses.",
  "تصدير": "Export",
  "الكل": "All",
  "ترتيب حسب: الأحدث": "Sort: newest first",
  "تسجيلات الطلاب": "Student Registrations",
  "سيظهر الطلاب هنا بعد إرسال نموذج تدريب صيفي منشور.": "Students appear here after submitting a published summer training form.",
  "لا توجد تسجيلات مطابقة": "No matching registrations",
  "رقم التسجيل": "Registration number",
  "اسم المتدرب": "Trainee name",
  "البرنامج التدريبي": "Training program",
  "تاريخ التقديم": "Submission date",
  "الدفع": "Payment",
  "تحقق": "Verify",
  "تفعيل": "Activate",
  "إلغاء": "Cancel",
  "أرشفة": "Archive",
  "إرسال لينك الباسورد": "Send password link",
  "تم إرسال لينك إعداد كلمة المرور.": "Password setup link sent.",
  "لم يتم إرسال لينك إعداد كلمة المرور. راجع إعدادات البريد.": "Password setup link was not sent. Check email settings.",
  "إدارة المجموعات": "Groups Management",
  "تنظيم ومتابعة مجموعات المتدربين داخل البرامج الفعالة.": "Organize and track trainee groups in active programs.",
  "إنشاء مجموعة تدريبية": "Create New Training Group",
  "اختر البرنامج": "Choose program",
  "اسم المجموعة": "Group Name",
  "الحد الأقصى للطلاب": "Max Students",
  "المواعيد": "Schedule",
  "إنشاء المجموعة": "Create Group",
  "تسكين طالب": "Assign Student",
  "المجموعة": "Group",
  "اختر المجموعة": "Choose group",
  "التسجيل": "Registration",
  "اختر التسجيل": "Choose registration",
  "تسكين": "Assign",
  "المجموعات الفعالة": "Active Groups",
  "لا توجد مجموعات تدريب صيفي بعد": "No summer groups yet",
  "أنشئ المجموعات بعد التحقق من التسجيلات.": "Create groups after verifying registrations.",
  "لا توجد مجموعات مطابقة": "No matching groups",
  "طلاب": "Students",
  "لا توجد مواعيد": "No schedule",
  "الحضور اليومي": "Daily Attendance",
  "إنشاء جلسات وتسجيل حضور مجموعات التدريب الصيفي.": "Create sessions and record summer training group attendance.",
  "إنشاء جلسة": "Create Session",
  "مجموعة التدريب": "Training Group",
  "عنوان الجلسة": "Session Title",
  "التاريخ": "Date",
  "وقت البداية": "Start Time",
  "حفظ الجلسة": "Save Session",
  "جلسة الحضور": "Attendance Session",
  "الجلسة المحددة": "Selected Session",
  "اختر الجلسة": "Choose session",
  "كشف الحضور": "Attendance Sheet",
  "تسجيلات فعالة متاحة": "active registrations available",
  "لا توجد جلسات بعد": "No sessions created yet",
  "أنشئ جلسة للمجموعة ثم سجّل حاضر أو غائب أو متأخر.": "Create a group session, then mark students present, absent, or late.",
  "الطالب": "Student",
  "حاضر": "Present",
  "غائب": "Absent",
  "متأخر": "Late",
  "إدارة المدفوعات": "Payment Management",
  "تسجيل المدفوعات وإصدار إيصالات خاصة بالتدريب الصيفي فقط.": "Record payments and issue summer training receipts only.",
  "إجمالي المدفوع": "Total paid",
  "المتبقي": "Remaining",
  "الملغي": "Voided",
  "الإيصالات": "Receipts",
  "تسجيل دفعة جديدة": "Record New Payment",
  "تسجيل معاملة دفع مرتبطة بتسجيل تدريب صيفي.": "Record a payment for a summer training registration.",
  "الطالب أو التسجيل": "Student or Submission",
  "ابحث بالاسم أو البريد أو رقم الطالب...": "Search by name, email, or student ID...",
  "المبلغ (EGP)": "Amount (EGP)",
  "طريقة الدفع": "Payment Method",
  "ملاحظات": "Notes",
  "تأكيد الدفع": "Confirm Payment",
  "حركات الدفع": "Payment Transactions",
  "المدفوعات الملغاة تبقى في السجل ولا تدخل في حساب الرصيد.": "Voided payments remain in history and are excluded from balances.",
  "لا توجد مدفوعات تدريب صيفي بعد": "No summer payments yet",
  "أي دفعة هنا تصدر إيصال تدريب صيفي ولا تلمس فواتير الأكاديمية الأساسية.": "Payments here issue a summer training receipt and do not change academy invoices.",
  "لا توجد مدفوعات مطابقة": "No matching payments",
  "الإيصال": "Receipt",
  "الطريقة": "Method",
  "المبلغ": "Amount",
  "سبب الإلغاء": "Reason for voiding",
  "طباعة الإيصال": "Print Receipt",
  "إلغاء الدفعة": "Void payment",
  "سبب إلغاء الدفعة": "Payment void reason",
  "نقدي": "Cash",
  "بطاقة": "Card",
  "إنستاباي": "Instapay",
  "فودافون كاش": "Vodafone Cash",
  "تحويل بنكي": "Bank Transfer",
  "اكتب اسم البرنامج": "Type program name",
  "رابط-البرنامج": "program-slug",
  "اكتب عنوان النموذج": "Type form title",
  "رابط-النموذج": "form-slug",
  "جلسة": "Session",
  "حقول": "fields",
  "عنوان النموذج مطلوب.": "Form title is required.",
  "إضافة حقول الجامعة والكلية": "Add university and faculty fields",
  "إدارة الكوبونات": "Coupon Management",
  "إنشاء كوبونات خصم مرتبطة بجامعة وكلية.": "Create discount coupons linked to a university and faculty.",
  "إنشاء كوبون جديد": "Create New Coupon",
  "كود الكوبون": "Coupon Code",
  "نوع الخصم": "Discount Type",
  "قيمة الخصم": "Discount Value",
  "مبلغ ثابت": "Fixed amount",
  "نسبة مئوية": "Percentage",
  "أقصى استخدام": "Max Uses",
  "إنشاء الكوبون": "Create Coupon",
  "الكوبونات الفعالة": "Active Coupons",
  "لا توجد كوبونات بعد": "No coupons yet",
  "أنشئ كوبونًا بعد إضافة خيارات الجامعة والكلية في البرامج.": "Create a coupon after adding university and faculty options to programs.",
  "لا توجد كوبونات مطابقة": "No matching coupons",
  "المستخدم": "Used",
  "تم إنشاء كوبون التدريب الصيفي.": "Summer training coupon created.",
  "أضف حقلًا واحدًا صحيحًا على الأقل.": "Add at least one valid field.",
  "أكواد الحقول يجب أن تكون غير مكررة": "Field codes must be unique",
  "يجب إضافة حقل واحد على الأقل.": "Add at least one field.",
  "كل حقل لازم يكون له كود داخلي.": "Every field needs an internal code.",
  "كل حقل لازم يكون له عنوان ظاهر.": "Every field needs a visible label.",
  "يوجد نموذج تدريب صيفي بنفس الرابط المختصر.": "A summer training form already uses this slug.",
  "تعذر حفظ نموذج التدريب الصيفي.": "Could not save the summer training form.",
  "تم إنشاء برنامج التدريب الصيفي.": "Summer training program created.",
  "تم تحديث برنامج التدريب الصيفي.": "Summer training program updated.",
  "تم حفظ نموذج التدريب الصيفي.": "Summer training form saved.",
  "تم تحديث نموذج التدريب الصيفي.": "Summer training form updated.",
  "تم نشر نموذج التدريب الصيفي.": "Summer training form published.",
  "تم تحديث حالة التسجيل.": "Registration status updated.",
  "تم إنشاء مجموعة التدريب الصيفي.": "Summer training group created.",
  "تعذر إنشاء مجموعة التدريب الصيفي.": "Could not create the summer training group.",
  "تم تسكين الطالب داخل مجموعة التدريب الصيفي.": "Student assigned to the summer training group.",
  "تعذر تسكين الطالب داخل مجموعة التدريب الصيفي.": "Could not assign the student to the summer training group.",
  "تم إنشاء جلسة التدريب الصيفي.": "Summer training session created.",
  "تعذر إنشاء جلسة التدريب الصيفي.": "Could not create the summer training session.",
  "تم تحديث الحضور.": "Attendance updated.",
  "تم تسجيل الدفعة. إيصال": "Payment recorded. Receipt",
  "تعذر تسجيل دفعة التدريب الصيفي.": "Could not record the summer training payment.",
  "تم إلغاء الدفعة وتعليم الإيصال المرتبط كملغي.": "Payment voided and its receipt marked voided.",
  "اختيار البرنامج واسم المجموعة مطلوبان.": "Program and group name are required.",
  "اختيار المجموعة والتسجيل مطلوبان.": "Group and registration are required.",
  "اختيار المجموعة والتاريخ مطلوبان.": "Group and date are required.",
  "اختيار التسجيل والمبلغ مطلوبان.": "Registration and amount are required.",
  "نماذج": "Forms",
  "منشور": "Published",
  "رابط": "Link",
  "مدفوع": "Paid",
  "مستحق": "Due",
  "ملغي": "Voided",
  "إيصال": "Receipt",
  "متبقي": "Remaining",
  "جديد": "New",
  "تم التحقق": "Verified",
  "تم التسكين": "Assigned",
  "نشط": "Active",
  "غير نشط": "Inactive",
  "مكتمل": "Completed",
  "مؤرشف": "Archived",
  "مسودة": "Draft",
  "مصدر": "Source",
  "مخطط": "Planned",
  "مجدول": "Scheduled",
  "تم التنفيذ": "Completed",
  "العربية": "Arabic",
  "Attendance Availability / طريقة الحضور": "Attendance Availability",
  "Online / أونلاين": "Online",
  "Offline / أوفلاين": "Offline",
  "Offline Branches / فروع الأوفلاين": "Offline Branches",
  "· آخر تحديث": "· Last updated",
  "· غير صالحة:": "· Invalid:",
  "· محدّثة:": "· Updated:",
  "تحديث القائمة": "Refresh list",
  "عرض الشهادة": "View certificate",
  "فريق الاستقبال": "Reception team",
  ". لربط رقم موظف آخر، يتم الربط من حساب ذلك الموظف.": ". To connect another employee's number, use that employee's account.",
  "PNG أو JPG أو WEBP — حتى 10 MB": "PNG, JPG or WEBP — up to 10 MB",
  "آخر الشهادات المرفوعة": "Latest uploaded certificates",
  "أي رقم تربطه هنا يُسجّل تلقائيًا باسم": "Any number connected here is automatically registered under",
  "إرسال Email": "Send Email",
  "إرسال WhatsApp": "Send WhatsApp",
  "إعادة المحاولة": "Retry",
  "ارفع أول شهادة من النموذج المجاور.": "Upload the first certificate using the form beside this list.",
  "ارفع ملف XLSX: الاسم في العمود A (NAME) ورقم الهاتف في العمود B. تُنشأ شهادة بالاسم لكل صف صالح، ولا يُحتفَظ برقم الهاتف كاملًا.": "Upload XLSX: name in column A (NAME), phone in column B. A certificate is created for each valid row; full phone numbers are not retained.",
  "تظهر أرقام الهاتف بشكل مخفي دائمًا.": "Phone numbers are always masked.",
  "تظهر لك محادثاتك ومحادثات الموظفين التابعين لك حسب المدير المباشر المسجّل في أريبيان.": "You can see your conversations and your reporting employees' conversations based on the manager recorded in Arabian.",
  "تعارض رقم/اسم:": "Phone/name conflicts:",
  "تعذر فتح واتساب": "Could not open WhatsApp",
  "توليد الشهادات من Excel": "Generate certificates from Excel",
  "جاري تحميل الإيصال...": "Loading receipt...",
  "جديدة:": "New:",
  "رفع شهادة جديدة": "Upload new certificate",
  "رقم الهاتف المسجل بالفعالية": "Phone number registered for the event",
  "شهادات فعالية البرمجة": "Programming Event Certificates",
  "صفوف صالحة:": "Valid rows:",
  "صفوف مكررة متطابقة:": "Identical duplicate rows:",
  "صورة الشهادة": "Certificate image",
  "طباعة": "Print",
  "عند استخدام الرقم نفسه مرة أخرى، تستبدل الصورة السابقة تلقائيًا وتبطل روابط معاينتها القديمة.": "Using the same number again replaces the previous image and invalidates its old preview links.",
  "إعادة الرفع لنفس الرقم تستبدل الشهادة السابقة.": "Uploading again for the same number replaces the previous certificate.",
  "اختيار ملف": "Choose file",
  "لم يتم اختيار ملف": "No file selected",
  "قالب Before Brand": "Before Brand template",
  "لا توجد شهادات مرفوعة بعد": "No uploaded certificates yet",
  "متجاوزة:": "Skipped:",
  "مساحة مؤقتة ومستقلة عن شهادات الطلاب الرسمية. لا يُخزَّن رقم الهاتف كاملًا؛ يظل البحث العام دقيقًا ومحميًا.": "This workspace is separate from official student certificates. Full phone numbers are not stored; public search remains exact and protected.",
  "ملف Excel": "Excel file",
  "واتساب — {0}": "WhatsApp — {0}",
  "يتم فتح واتساب…": "Opening WhatsApp…",
  "← رجوع": "← Back"
};
